if (!window.RationalFuturismForm) {
    class RationalFuturismForm {
        constructor(formElement) {
            this.form = formElement || document.querySelector('form[action*="/cart/add"]');
            this.container = this.form ? (this.form.closest('.product') || this.form.closest('.shopify-section') || this.form) : document.body;

            if (!this.container) {
                console.error("❌ RF: Container not found!");
                return;
            }
            console.log("🚀 RF: Form Initializing...");

            this.config = window.rfConfig || {};
            // [FIX] Prefer rfConfig.mainVariants as it contains full option/availability data
            if (this.config.mainVariants) {
                this.productData = { variants: this.config.mainVariants, title: this.config.productTitle || "" };
            } else {
                this.productData = window.rfShopifyData || {};
            }
            this.formType = String(this.config.formType || 'unknown').trim();

            console.log("RF: Booting with Form Type:", this.formType);

            try {
                const fb = window.RF_FIREBASE;
                if (fb) {
                    this.storage = fb.storage;
                    console.log("🔥 RF: Firebase Initialized Successfully (via RF_FIREBASE)");
                } else {
                    console.warn("⏳ RF: RF_FIREBASE not yet available, will retry on upload");
                }
            } catch (err) {
                console.error("❌ RF: Firebase Initialization Failed", err);
                alert("システムエラー: ファイルアップロード機能が初期化できませんでした。");
            }

            this.uploadedFiles = [];
            this.currentBasePrice = 0;
            this.testPrintPrice = 0;

            // Dynamic Size List
            this.STANDARD_SIZES = STANDARD_SIZE_DICT; // [FIX] Bind global dict to instance for usage in helpers
            this.availableSizes = this.parseProductSizes();

            this.elements = {
                sizeSelect: this.container.querySelector('#rf-size-select'),
                sizeModeRadios: this.container.querySelectorAll('input[name="rf-size-mode"]'),
                standardContainer: this.container.querySelector('#rf-size-standard-container'),
                customContainer: this.container.querySelector('#rf-size-custom-container'),
                customShort: this.container.querySelector('#rf-size-short'),
                customLong: this.container.querySelector('#rf-size-long'),
                customDisplay: this.container.querySelector('#rf-custom-display'),
                priceDisplay: this.container.querySelector('#rf-price-display'),
                layoutSection: this.container.querySelector('#rf-section-layout'),
                layoutRadios: this.container.querySelectorAll('input[name="properties[印刷レイアウト]"]'),
                borderlessSection: this.container.querySelector('#rf-section-borderless'),
                dataSection: this.container.querySelector('#rf-section-data'),
                marginSection: this.container.querySelector('#rf-section-margin'),
                marginWidthInputs: this.container.querySelector('#rf-margin-width-inputs'),
                marginSizeInputs: this.container.querySelector('#rf-margin-size-inputs'),
                dropzone: this.container.querySelector('#rf-dropzone'),
                fileInput: this.container.querySelector('#rf-file-input'),
                fileList: this.container.querySelector('#rf-file-list'),
                uploadError: this.container.querySelector('#rf-upload-error'),
                hiddenFileNames: this.container.querySelector('#rf-file-names'),
                hiddenFileUrls: this.container.querySelector('#rf-file-urls'),
                totalAmountDisplay: this.container.querySelector('#rf-total-price') || this.container.querySelector('#rf-total-amount'),
                // Qty
                qtyMinus: this.container.querySelector('#rf-qty-minus'),
                qtyPlus: this.container.querySelector('#rf-qty-plus'),
                qtyInput: this.container.querySelector('#rf-qty-input'),
                // Test Print
                testPrintCheck: this.container.querySelector('#rf-check-test-print'),
                testPrintDetails: this.container.querySelector('#rf-test-print-details'),
                testPrintQtyInput: this.container.querySelector('#rf-tp-qty-input'),
                testPrintMinus: this.container.querySelector('#rf-tp-qty-minus'),
                testPrintPlus: this.container.querySelector('#rf-tp-qty-plus'),
                testPrintData: this.container.querySelector('#rf-test-print-data'),
                testPrintFilename: this.container.querySelector('#rf-tp-filename'),
                testPrintAddress: this.container.querySelector('#rf-tp-address')
            };

            // Test Print Logic Init
            if (this.elements.testPrintData) {
                this.testPrintPrice = parseInt(this.elements.testPrintData.dataset?.price) || 0;
                this.testPrintVariantId = this.elements.testPrintData.dataset?.variantId;
            } else {
                this.testPrintPrice = 0;
                this.testPrintVariantId = null;
            }

            // Track last checked layout for toggle/deselect behavior
            this.lastLayoutRadio = document.querySelector('input[name="properties[印刷レイアウト]"]:checked');

            this.initListeners();
            if (typeof this.setupVisibility === 'function') this.setupVisibility(); // [NEW] Initial visibility setup
            this.initHelperModal(); // [NEW] Layout Help Modal
            this.disableNumberScroll();



            // Init total
            this.updateTotalDisplay();

            // Init state check (for reload or default checks)
            this.checkInitialLayout();

            // Init Size Price from default selection (A5)
            if (this.elements.sizeSelect && this.elements.sizeSelect.value) {
                this.handleSizeSelectChange({ target: this.elements.sizeSelect });
            }
        }



        checkInitialLayout() {
            const checkedLayout = (this.container && typeof this.container.querySelector === 'function')
                ? this.container.querySelector('input[name="properties[印刷レイアウト]"]:checked')
                : null;
            if (checkedLayout) {
                this.handleLayoutChange({ target: checkedLayout });
            }
        }

        parseProductSizes() {
            const sizes = [];
            if (!this.productData.variants) return sizes;

            this.productData.variants.forEach(variant => {
                // [NEW] Skip sold out items
                if (!variant.available) return;

                const title = variant.title;
                let width = 0, height = 0;

                // 1. Try to find dimensions in title e.g. "200x200", "200×200"
                const dimMatch = title.match(/(\d+)\s*[x×]\s*(\d+)/);
                if (dimMatch) {
                    width = parseInt(dimMatch[1]);
                    height = parseInt(dimMatch[2]);
                } else {
                    // 2. Try Dictionary Lookup (e.g. "A4")
                    // Clean title: remove stuff in parens if needed, or exact match
                    // Strategy: Check if title *starts with* a known key
                    for (const [key, dims] of Object.entries(STANDARD_SIZE_DICT)) {
                        // Check exact match or "Key (" or "Key（" or "Key /" (Unified)
                        if (title === key || title.startsWith(key + '(') || title.startsWith(key + '（') || title.startsWith(key + ' /')) {
                            width = dims[0];
                            height = dims[1];
                            break;
                        }
                    }
                }

                if (width > 0 && height > 0) {
                    sizes.push({
                        name: title, // Use Variant Title as name
                        short: Math.min(width, height),
                        long: Math.max(width, height),
                        id: variant.id,
                        price: variant.price,
                        options: [variant.option1, variant.option2, variant.option3] // [NEW] Capture options
                    });
                }
            });

            // Sort sizes by Area (Small -> Large) for fitting logic
            sizes.sort((a, b) => (a.short * a.long) - (b.short * b.long));

            // [NEW] Trigger UI availability check immediately
            // (Wait for DOM to be ready implicitly or call it?)
            // Since we are in constructor and element exists, we can call it.
            setTimeout(() => this.updateAvailabilityUI(), 0);

            return sizes;
        }

        // [NEW] Update UI Availability based on Valid Variants
        updateAvailabilityUI() {
            // [FIX] 統合フォーム(額装 aluminum_unified / wood_unified)はサイズ選択肢を
            // 全バリアントの JSON(rf-custom-variants.json)から生成している。一方 productData.variants は
            // ストアフロントが先頭250件に切り詰めるため(額装は580/768バリアント)、ここで在庫判定すると
            // 251件目以降のサイズが「在庫切れ扱い」で hidden/disabled になる(iOS は hidden を無視するため
            // グレーで選べない状態になる)。額装は全バリアント inventory_policy=continue(在庫切れでも販売)
            // なので、ここでの非表示/disabled 化は行わない(全サイズ選択可)。
            if (['aluminum_unified', 'wood_unified'].includes(this.formType) || this._unifiedOptionsPopulated) return;

            // 1. Size Dropdown: Hide options that have NO available variants
            if (this.elements.sizeSelect) {
                // 2-option otameshi_print (テスト印刷 type × paper) uses handleOtameshiTypeChange
                // for filtering. opt.value is the PAPER (option2) but this function compares to
                // v.option1 (PLAN), so it would unconditionally hide every option here.
                if (this.elements.sizeSelect.dataset.otameshiMulti === 'true') return;

                const options = this.elements.sizeSelect.querySelectorAll('option');
                const variants = this.productData?.variants || [];

                // [FIX] If no variants or all unavailable, show all options (fallback)
                const hasAnyAvailable = variants.some(v => v.available);
                if (variants.length === 0 || !hasAnyAvailable) {
                    console.log("RF: updateAvailabilityUI - No available variants, showing all options.");
                    options.forEach(opt => {
                        if (opt.value === "") return;
                        opt.style.display = '';
                        opt.hidden = false;
                        opt.disabled = false;
                    });
                    return;
                }

                options.forEach(opt => {
                    if (opt.value === "") return; // Skip placeholder

                    // Check if there is AT LEAST ONE available variant with this Size (Option1)
                    const hasStock = variants.some(v =>
                        v.available && v.option1 === opt.value
                    );

                    if (!hasStock) {
                        // [MODIFIED] Hide instead of Disable
                        opt.style.display = 'none';
                        opt.hidden = true; // Support for some browsers
                        opt.disabled = true; // Fallback ensure unselectable
                    } else {
                        opt.style.display = '';
                        opt.hidden = false;
                        opt.disabled = false;
                        // Remove (売切れ) if it was added (cleanup from previous logic if persistent)
                        opt.textContent = opt.textContent.replace(' (売切れ)', '');
                    }
                });
            }
        }

        // [NEW] Update Available Colors for Selected Size
        updateAvailableColors(sizeValue) {
            if (!sizeValue) return;

            // [2026-06-19] Owner 指示: 全 form type で「(サイズ×色) variant の存在＋在庫(在庫切れでも
            // 販売継続=available)」で色の表示/非表示を分ける。旧コードは wood_panel/book_matte を
            // 「色はサイズ非依存」と誤仮定して早期 return していたが、実データでは wood_panel の
            // B1ノビ/B0 でブラックのみ在庫切れ(DENY)=非可用 → ブラックを選べて ATC が黙って落ちる(⑤)。
            // mainVariants(=productData.variants) は Liquid の variant.available を保持しており、
            // available は「在庫>0 OR 在庫切れでも販売継続(continue) OR 在庫未追跡」を表す = Owner ルールそのもの。
            // 万一サイズ一致 variant が皆無なら下の availableColors.size===0 フォールバックで全色表示(安全側)。

            const isUnified = ['aluminum_unified', 'wood_unified'].includes(this.formType);

            // [FIX] For unified forms, use customOptions (from JSON) instead of productData.variants
            // Filter by product handle to avoid cross-product matching
            let sourceVariants;
            if (isUnified && this.customOptions && this.customOptions.length > 0) {
                const productHandle = this.formType === 'aluminum_unified' ? 'framing-p002' : 'framing-p001';
                sourceVariants = this.customOptions.filter(v => v.product_handle === productHandle);
            } else {
                sourceVariants = this.productData?.variants || [];
            }

            // Find all available variants for this size
            const validVariants = sourceVariants.filter(v => {
                const opt1 = v.options ? v.options[0] : v.option1;
                // For unified JSON, there's no 'available' property, assume all are available
                const isAvailable = v.available !== undefined ? v.available : true;
                return isAvailable && opt1 === sizeValue;
            });

            // Extract available Color values (Option 2 or Option 3)
            const availableColors = new Set(validVariants.map(v => {
                if (isUnified) {
                    return v.options ? v.options[2] : v.option3;
                } else {
                    let colorOpt = v.options ? v.options[1] : v.option2;
                    if (!colorOpt && v.options && v.options[2]) {
                        colorOpt = v.options[2];
                    } else if (!colorOpt && v.option3) {
                        colorOpt = v.option3;
                    }
                    return colorOpt;
                }
            }));

            console.log(`RF: updateAvailableColors - Size: ${sizeValue}, Available Colors:`, [...availableColors]);

            // Update Color Inputs
            const colorInputs = this.container.querySelectorAll('input[name="properties[フレームカラー]"], input[name="properties[側面カラー]"], input[name="properties[テープカラー]"], input[name="properties[側面テープカラー]"]');
            colorInputs.forEach(input => {
                const colorVal = input.value;
                const parent = input.closest('.rf-radio-card, label');

                if (availableColors.has(colorVal)) {
                    input.disabled = false;
                    if (parent) {
                        // [MODIFIED] Show
                        parent.style.display = '';
                        parent.classList.remove('rf-disabled');
                        parent.style.opacity = '1';
                        parent.style.pointerEvents = '';
                    }
                } else {
                    input.disabled = true;
                    if (parent) {
                        // [MODIFIED] Hide
                        parent.style.display = 'none'; // Hide completely per request

                        // If this was checked, uncheck it
                        if (input.checked) {
                            input.checked = false;
                            parent.classList.remove('active');
                        }
                    }
                }
            });

            // [FIX] If no colors are shown, show the color section anyway with all colors
            if (availableColors.size === 0) {
                colorInputs.forEach(input => {
                    input.disabled = false;
                    const parent = input.closest('.rf-radio-card, label');
                    if (parent) {
                        parent.style.display = '';
                        parent.classList.remove('rf-disabled');
                        parent.style.opacity = '1';
                        parent.style.pointerEvents = '';
                    }
                });
            }
        }

        // [NEW] 加工タイプ(額入れのみ / オーバーマット / ブックマット / スチレンパネル裏貼り /
        // オーバーマット&スチレンパネル裏貼り)の選択可否を「現在のサイズモード」に応じて更新する。
        // processing_type_section.liquid は 5 種すべて静的描画するため、実在しない組み合わせを
        // ここでゲート(非表示+disable+チェック解除)しないと、存在しない variant をカートに入れようとして失敗する。
        //   - 定形(standard)モード: 選択中サイズに variant が実在する option2(加工タイプ)だけ許可。
        //       大判ブックマット等、Shopify から variant 削除済の組み合わせを選べないようにする。
        //       データ源は customOptions(rf-custom-variants.json)= 全 variant を保持し、
        //       ストアフロント 250 件切り詰めの影響を受けない。
        //   - 定形外(custom)モード: ブックマットは製造上限 短辺 763mm / 長辺 1066mm を超えると非表示。
        //       他の加工タイプは定形外でも制限しない(従来通り)。
        // updateAvailableColors と同じ設計(JSON 駆動・カード単位で出し分け)。
        updateProcessingTypeAvailability() {
            // 加工タイプ選択がある統合フォームのみ対象(他フォームは加工タイプ固定 or 無し)
            if (!['aluminum_unified', 'wood_unified'].includes(this.formType)) return;

            const radios = document.querySelectorAll('input[name="rf-processing-type"]');
            if (!radios.length) return;

            const isCustom = document.querySelector('input[name="rf-size-mode"]:checked')?.value === 'custom';

            // 加工タイプごとの許可判定関数を構築
            let isAllowed;
            if (isCustom) {
                // 定形外: 入力寸法でブックマット上限を判定。他タイプは制限なし。
                const s = parseInt(this.elements.customShort?.value) || 0;
                const l = parseInt(this.elements.customLong?.value) || 0;
                const short = Math.min(s, l);
                const long = Math.max(s, l);
                const dimsEntered = short > 0 && long > 0;
                const BOOKMAT_MAX_SHORT = 763;  // ブックマット製造上限(短辺)
                const BOOKMAT_MAX_LONG = 1066;  // ブックマット製造上限(長辺)
                isAllowed = (type) => {
                    if (type === 'ブックマット') {
                        if (!dimsEntered) return true; // 未入力時は隠さない
                        return short <= BOOKMAT_MAX_SHORT && long <= BOOKMAT_MAX_LONG;
                    }
                    return true;
                };
            } else {
                // 定形: 選択中サイズに実在する加工タイプ(variant)のみ許可
                const sizeValue = this.elements.sizeSelect ? this.elements.sizeSelect.value : '';
                const productHandle = this.formType === 'aluminum_unified' ? 'framing-p002' : 'framing-p001';
                const source = (this.customOptions && this.customOptions.length > 0)
                    ? this.customOptions.filter(v => v.product_handle === productHandle)
                    : [];
                // customOptions 未ロード or サイズ未選択はゲートせず全表示(フェイルオープン)
                const noGate = source.length === 0 || !sizeValue;
                const availableTypes = new Set();
                if (!noGate) {
                    source.forEach(v => {
                        const opt1 = v.options ? v.options[0] : v.option1;
                        const opt2 = v.options ? v.options[1] : v.option2;
                        if (opt1 === sizeValue && opt2) availableTypes.add(opt2);
                    });
                }
                isAllowed = (type) => noGate || availableTypes.has(type);
            }

            let uncheckedInvalid = false;
            radios.forEach(input => {
                const card = input.closest('.rf-radio-card, label');
                if (isAllowed(input.value)) {
                    input.disabled = false;
                    if (card) {
                        card.style.display = '';
                        card.classList.remove('rf-disabled');
                        card.style.opacity = '';
                        card.style.pointerEvents = '';
                    }
                } else {
                    input.disabled = true;
                    if (card) card.style.display = 'none';
                    if (input.checked) {
                        input.checked = false;
                        if (card) card.classList.remove('active');
                        uncheckedInvalid = true;
                    }
                }
            });

            // 選択中だった加工タイプが無効化された場合、依存 UI(用紙 / 窓抜き / 光沢警告 / マット余白 / 合計)を再評価
            if (uncheckedInvalid) {
                if (typeof this.updatePaperTypeOptions === 'function') this.updatePaperTypeOptions();
                if (typeof this.updatePaperSizeOptions === 'function') this.updatePaperSizeOptions();
                if (typeof this.updateWindowSizeVisibility === 'function') this.updateWindowSizeVisibility();
                if (typeof this.updateGlossyWarningVisibility === 'function') this.updateGlossyWarningVisibility();
                if (typeof this.updateMatMarginWarning === 'function') this.updateMatMarginWarning();
                if (typeof this.updateTotalDisplay === 'function') this.updateTotalDisplay();
            }
        }

        initListeners() {
            // 用紙診断からの着地印。フォームの状態に依存しないので最初に打つ。
            // (お試し用のラジオが初期選択されている時だけ動く場所に置くと、
            //  他フォームや初期未選択の着地で取りこぼす)
            this._tagCartSource();

            // [NEW] Global Change/Input Listener for Progressive UX
            if (this.container && typeof this.container.addEventListener === 'function') {
                this.container.addEventListener('change', (e) => {
                    const tag = e.target.tagName;
                    if (tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA') {
                        if (typeof this.updateVisualState === 'function') {
                            setTimeout(() => this.updateVisualState(), 50);
                        }
                    }
                });
                this.container.addEventListener('input', (e) => {
                    if (e.target.type === 'text' || e.target.type === 'number') {
                        if (typeof this.updateVisualState === 'function') {
                            setTimeout(() => this.updateVisualState(), 50);
                        }
                    }
                });
            }

            // Layout Radios (Toggle/Deselect Logic) handled below

            // Size Mode Switcher
            if (this.elements.sizeModeRadios && typeof this.elements.sizeModeRadios.forEach === 'function') {
                this.elements.sizeModeRadios.forEach(radio => {
                    radio.addEventListener('change', (e) => this.handleSizeModeChange(e));
                });
            }

            // [FIX] Paper Size Mode Switcher (Standard vs Custom Paper Size)
            const paperModeRadios = this.container.querySelectorAll('input[name="rf-paper-size-mode"]');
            if (paperModeRadios && typeof paperModeRadios.forEach === 'function') {
                paperModeRadios.forEach(radio => {
                    radio.addEventListener('change', (e) => {
                        const mode = e.target.value;
                        const standardWrapper = this.container.querySelector('#rf-paper-size-standard-wrapper');
                        const customWrapper = this.container.querySelector('#rf-paper-size-custom-wrapper');
                        
                        if (mode === 'standard') {
                            if (standardWrapper) standardWrapper.style.display = 'block';
                            if (customWrapper) customWrapper.style.display = 'none';
                            if (typeof this.updatePaperSizeOptions === 'function') {
                                this.updatePaperSizeOptions();
                            }
                        } else {
                            if (standardWrapper) standardWrapper.style.display = 'none';
                            if (customWrapper) customWrapper.style.display = 'block';
                            if (typeof this.updatePaperCustomMatch === 'function') {
                                this.updatePaperCustomMatch();
                            }
                        }
                        if (typeof this.updateVisualState === 'function') this.updateVisualState();
                    });
                });
            }

            // --- Size Switcher True Toggle ---
            // Overrides native radio behavior to allow "flip on any click"
            const switchers = this.container.querySelectorAll('.rf-size-switcher');
            if (switchers && switchers.length > 0) {
                switchers.forEach(switcher => {
                    // [ST-31] this.container は商品セクションに解決されるため、同一ページに
                    // 複数フォームインスタンスがあると同じスイッチャーへ二重バインドし得る。
                    // トグルが1クリックで2回発火して元に戻るのを防ぐため、1スイッチャー1ハンドラを保証する。
                    if (switcher.dataset.rfSwitcherBound) return;
                    switcher.dataset.rfSwitcherBound = '1';
                    switcher.addEventListener('click', (e) => {
                        // Prevent native label/radio default handling
                        e.preventDefault();

                        const radios = switcher.querySelectorAll('input[type="radio"]');
                        if (radios.length < 2) return;

                        const standardRadio = radios[0];
                        const customRadio = radios[1];

                        // Toggle Logic
                        if (standardRadio.checked) {
                            customRadio.checked = true;
                            standardRadio.checked = false;
                            customRadio.dispatchEvent(new Event('change', { bubbles: true }));
                        } else {
                            standardRadio.checked = true;
                            customRadio.checked = false;
                            standardRadio.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    });
                });
            }

            // Size Select (Standard)
            if (this.elements.sizeSelect && typeof this.elements.sizeSelect.addEventListener === 'function') {
                this.elements.sizeSelect.addEventListener('change', (e) => this.handleSizeSelectChange(e));
            }

            // [NEW] Otameshi Print: Type selector (セット/シングル) — filters paper dropdown by selected type
            const otameshiTypeRadios = (this.container && typeof this.container.querySelectorAll === 'function')
                ? this.container.querySelectorAll('input.rf-otameshi-type')
                : [];
            if (otameshiTypeRadios && otameshiTypeRadios.length > 0 && typeof otameshiTypeRadios.forEach === 'function') {
                otameshiTypeRadios.forEach(radio => {
                    radio.addEventListener('change', () => {
                        if (!radio.checked) return;
                        this.handleOtameshiTypeChange(radio.value);
                        this._gaOtameshiType(radio);   // GA4: どちらの分岐を選んだか
                    });
                });
                // Initial sync (the checked radio from Liquid)
                const initiallyChecked = Array.from(otameshiTypeRadios).find(r => r.checked);
                if (initiallyChecked) {
                    // Defer to ensure sizeSelect element exists
                    setTimeout(() => {
                        this.handleOtameshiTypeChange(initiallyChecked.value);
                        this._applyVariantPreselect(otameshiTypeRadios);   // ?variant= で着地したら用紙まで選択済みにする
                    }, 0);
                }
            }

            // [FIX] Paper Type Select Logic (Explicit Binding)
            if (this.elements.paperSelect) {
                this.elements.paperSelect.addEventListener('change', (e) => {
                    this.handlePaperTypeChange(e);
                });
            }

            // Custom Size Input Updates
            [this.elements.customShort, this.elements.customLong].forEach(el => {
                if (el && typeof el.addEventListener === 'function') {
                    el.addEventListener('input', () => this.updateCustomCalculation());
                }
            });

            // Layout Radio Change (with Deselect/Toggle Logic)
            // [FIX] Use mousedown to capture pre-click state, change for selection, click for deselect
            if (this.elements.layoutRadios && typeof this.elements.layoutRadios.forEach === 'function') {
                this.elements.layoutRadios.forEach(radio => {
                    const card = radio.closest('.rf-radio-card');

                    // Capture whether radio was checked BEFORE native behavior changes it
                    const captureState = () => { radio._wasCheckedBeforeClick = radio.checked; };
                    if (card) card.addEventListener('mousedown', captureState);
                    radio.addEventListener('mousedown', captureState);

                    // 'change' fires when the radio becomes newly checked (native, once only)
                    radio.addEventListener('change', () => {
                        this.handleLayoutChange({ target: radio });
                        this.updateTotalDisplay();
                        this.updateVisualState();
                        // [NEW] photo_card の場合、レイアウト変更で precheck セクション制御等を再評価
                        if (typeof this.updateLayoutOptionsAvailability === 'function') {
                            this.updateLayoutOptionsAvailability();
                        }
                    });

                    // 'click' handles deselect: only if radio was ALREADY checked before this interaction
                    radio.addEventListener('click', () => {
                        if (radio._wasCheckedBeforeClick) {
                            // Was already checked before mousedown → user wants to deselect
                            radio.checked = false;
                            this.handleLayoutChange({ target: radio });
                            this.updateTotalDisplay();
                            this.updateVisualState();
                        }
                        radio._wasCheckedBeforeClick = false;
                    });
                });
            }

            // Margin Type Radio Change
            const marginRadios = (this.container && typeof this.container.querySelectorAll === 'function')
                ? this.container.querySelectorAll('input[name="properties[フチ処理]"]')
                : [];
            if (marginRadios && typeof marginRadios.forEach === 'function') {
                marginRadios.forEach(radio => {
                    radio.addEventListener('change', (e) => {
                        this.handleMarginTypeChange(e);
                        this.updateTotalDisplay();
                        this.updateVisualState();
                    });
                    if (radio.checked) {
                        this.handleMarginTypeChange({ target: radio });
                    }
                });
            }

            // Test Print Listeners
            if (this.elements.testPrintCheck && typeof this.elements.testPrintCheck.addEventListener === 'function') {
                this.elements.testPrintCheck.addEventListener('change', (e) => {
                    this.handleSimpleToggle(e.target.checked, this.elements.testPrintDetails);
                    this.updateTotalDisplay();
                });
            }
            if (this.elements.testPrintMinus && typeof this.elements.testPrintMinus.addEventListener === 'function') {
                this.elements.testPrintMinus.addEventListener('click', (e) => { e.preventDefault(); this.updateTestPrintQty(-1); });
            }
            if (this.elements.testPrintPlus && typeof this.elements.testPrintPlus.addEventListener === 'function') {
                this.elements.testPrintPlus.addEventListener('click', (e) => { e.preventDefault(); this.updateTestPrintQty(1); });
            }
            if (this.elements.testPrintQtyInput && typeof this.elements.testPrintQtyInput.addEventListener === 'function') {
                this.elements.testPrintQtyInput.addEventListener('change', () => this.updateTestPrintQty(0));
            }

            // Quantity Logic
            if (this.elements.qtyMinus && typeof this.elements.qtyMinus.addEventListener === 'function') {
                if (!this.elements.qtyMinus._rf_bound) {
                    this.elements.qtyMinus.addEventListener('click', (e) => { e.preventDefault(); e.stopImmediatePropagation(); this.updateQuantity(-1); });
                    this.elements.qtyMinus._rf_bound = true;
                }
            }
            if (this.elements.qtyPlus && typeof this.elements.qtyPlus.addEventListener === 'function') {
                if (!this.elements.qtyPlus._rf_bound) {
                    this.elements.qtyPlus.addEventListener('click', (e) => { e.preventDefault(); e.stopImmediatePropagation(); this.updateQuantity(1); });
                    this.elements.qtyPlus._rf_bound = true;
                }
            }
            if (this.elements.qtyInput && typeof this.elements.qtyInput.addEventListener === 'function') {
                if (!this.elements.qtyInput._rf_bound) {
                    this.elements.qtyInput.addEventListener('change', () => this.updateQuantity(0));
                    this.elements.qtyInput._rf_bound = true;
                }
            }

            // [Unified] Processing Type Change
            const procRadios = (this.container && typeof this.container.querySelectorAll === 'function')
                ? this.container.querySelectorAll('input[name="rf-processing-type"]')
                : [];
            if (procRadios && typeof procRadios.forEach === 'function') {
                procRadios.forEach(radio => {
                    radio.addEventListener('change', (e) => {
                        console.log("RF: Processing Type Changed ->", e.target.value);
                        if (typeof this.setupVisibility === 'function') this.setupVisibility(); // Original line
                        if (typeof this.updateLayoutWarningVisibility === 'function') this.updateLayoutWarningVisibility(); // [NEW] Sync Layout Warning
                        if (typeof this.updateTotalDisplay === 'function') this.updateTotalDisplay();
                        if (typeof this.updateVisualState === 'function') this.updateVisualState();
                    });
                });
            }

            // Initial check for processing type related visibility and warnings
            if (typeof this.updateLayoutWarningVisibility === 'function') this.updateLayoutWarningVisibility(); // [NEW] Initial Sync

            // Focus Mode Interactions (Grouped) - Removed due to user feedback

            // [NEW] Caption Panel Toggles (radio-based: 「希望する」 vs 「完全データ入稿」)
            const captionRadios = this.container.querySelectorAll('input[name="properties[出力データ作成オプション]"]');
            const captionDetails = this.container.querySelector('#rf-caption-details');
            const captionNoOptionDetails = this.container.querySelector('#rf-caption-no-option-details');
            const captionLayout1 = this.container.querySelector('#rf-check-caption-layout-confirm1');
            const captionLayout2 = this.container.querySelector('#rf-check-caption-layout-confirm2');

            if (captionRadios.length > 0) {
                const getCaptionMode = () => {
                    const checked = this.container.querySelector('input[name="properties[出力データ作成オプション]"]:checked');
                    return checked ? checked.value : '';
                };
                const updateCaptionToggles = () => {
                    const mode = getCaptionMode();
                    const isCreate = (mode === '希望する');
                    if (captionDetails) this.handleSimpleToggle(isCreate, captionDetails);
                    if (captionNoOptionDetails) this.handleSimpleToggle(!isCreate, captionNoOptionDetails);

                    if (captionLayout1) {
                        captionLayout1.disabled = !isCreate;
                        if (!isCreate) captionLayout1.checked = false;
                    }
                    if (captionLayout2) {
                        captionLayout2.disabled = isCreate;
                        if (isCreate) captionLayout2.checked = false;
                    }
                    this.updateShippingPrefixText();
                };

                captionRadios.forEach(r => {
                    r.addEventListener('change', updateCaptionToggles);
                });

                // Init
                if (captionDetails || captionNoOptionDetails) {
                    updateCaptionToggles();
                }
            }

            const captionTemplateSelect = this.container.querySelector('#rf-caption-template');
            const designInstructionGroup = this.container.querySelector('#rf-caption-design-instruction');
            if (captionTemplateSelect && designInstructionGroup && typeof captionTemplateSelect.addEventListener === 'function') {
                captionTemplateSelect.addEventListener('change', (e) => {
                    const isTypeA = e.target.value === 'Aタイプ';
                    this.toggleContent(designInstructionGroup, isTypeA);
                });
                // Initial check
                this.toggleContent(designInstructionGroup, captionTemplateSelect.value === 'Aタイプ');
            }

            // [NEW #P30328] レイアウト確認チェックボックスで納期テキスト動的変更
            const layoutConfirmChecks = (this.container && typeof this.container.querySelectorAll === 'function')
                ? this.container.querySelectorAll('input[name="properties[レイアウト確認]"]')
                : [];
            if (layoutConfirmChecks && typeof layoutConfirmChecks.forEach === 'function') {
                layoutConfirmChecks.forEach(check => {
                    if (check && typeof check.addEventListener === 'function') {
                        check.addEventListener('change', () => {
                            this.updateShippingPrefixText();
                        });
                    }
                });
            }
            // Initial check
            this.updateShippingPrefixText();


            // File Upload - ROBUST BINDING
            // [FIX] Use a flag to prevent double binding
            if (this._uploadListenersBound) {
                console.log("⏭️ RF: Upload listeners already bound, skipping.");
            } else {
                const dz = this.container.querySelector('#rf-dropzone');
                const inp = this.container.querySelector('#rf-file-input');

                if (dz && inp && typeof dz.cloneNode === 'function') {
                    console.log("✅ RF: File Upload Elements Found. Binding listeners now.");
                    this._uploadListenersBound = true;

                    // [FIX] Clone BOTH dropzone and file input to prevent duplicate listeners
                    const newDz = dz.cloneNode(true);
                    if (dz.parentNode) {
                        dz.parentNode.replaceChild(newDz, dz);
                    }
                    this.elements.dropzone = newDz;

                    // [FIX] Re-acquire the file input from the cloned dropzone
                    const newInp = newDz.querySelector('#rf-file-input') || this.container.querySelector('#rf-file-input');
                    this.elements.fileInput = newInp;

                    // Re-bind Click
                    this.elements.dropzone.addEventListener('click', (e) => {
                        if (e.target === newInp || e.target.closest('.rf-file-remove')) return;
                        console.log("🖱️ RF: Dropzone clicked. Triggering input click...");
                        newInp.click();
                    });

                    // CRITICAL FIX: Stop propagation from input to prevent infinite loop
                    newInp.addEventListener('click', (e) => e.stopPropagation());

                    // Re-bind Input Change
                    newInp.addEventListener('change', (e) => {
                        console.log("📂 RF: File input changed", e.target.files);
                        if (e.target.files && e.target.files.length > 0) {
                            this.handleFiles(e.target.files);
                        }
                    });

                    // Re-bind Drag Events
                    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
                        this.elements.dropzone.addEventListener(eventName, (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                        }, false);
                    });
                    ['dragenter', 'dragover'].forEach(eventName => {
                        this.elements.dropzone.addEventListener(eventName, () => this.elements.dropzone.classList.add('rf-dragover'), false);
                    });
                    ['dragleave', 'drop'].forEach(eventName => {
                        this.elements.dropzone.addEventListener(eventName, () => this.elements.dropzone.classList.remove('rf-dragover'), false);
                    });
                    this.elements.dropzone.addEventListener('drop', (e) => {
                        const dt = e.dataTransfer;
                        console.log("⬇️ RF: File Dropped", dt.files);
                        this.handleFiles(dt.files);
                    }, false);

                } else {
                    console.error("❌ RF: Critical Error - File Upload Elements MISSING", { dz, inp });
                }
            }

            // Add to Cart Button Logic (Deferred to ensure ID is injected)
            // Add to Cart Button Logic (Deferred to ensure ID is injected)
            // [FIX] Consolidate Listener Logic
            const initRobustCart = () => {
                // Wait slightly for liquid script to run
                setTimeout(() => {
                    const form = document.querySelector('form[action$="/cart/add"]');
                    // [FIX] Try Custom ID first, then fallback to Native Theme Button (name="add")
                    const addToCartBtn = this.container.querySelector('#rf-add-to-cart') || form?.querySelector('button[name="add"]');

                    if (addToCartBtn) {
                        console.log("✅ RF: Add to Cart Button Found. Binding listener.");
                        this.elements.addToCartBtn = addToCartBtn;

                        // Remove existing listeners (theme default) by cloning
                        const newBtn = addToCartBtn.cloneNode(true);
                        addToCartBtn.parentNode.replaceChild(newBtn, addToCartBtn);
                        this.elements.addToCartBtn = newBtn;
                        // [FIX ST-47b 2026-07-31] 文言復元用にテーマ既定ラベルを控える (書き換え前に1度だけ)。
                        if (!newBtn.dataset.rfOriginalText) newBtn.dataset.rfOriginalText = (newBtn.textContent || '').trim();

                        newBtn.addEventListener('click', (e) => {
                            console.log("🛒 RF: Cloned Button Clicked");
                            e.preventDefault();
                            e.stopPropagation();
                            e.stopImmediatePropagation();
                            this.handleRobustSubmit(e);
                        });
                    } else {
                        console.warn("⚠️ RF: Add to Cart Button NOT found via ID #rf-add-to-cart or name='add'");
                    }

                    if (form) {
                        // [FIX] Block Implicit Form Submission (Enter key, etc)
                        form.addEventListener('submit', (e) => {
                            console.log("🛑 RF: Native Form Submit Blocked");
                            e.preventDefault();
                            e.stopPropagation();
                            return false;
                        }, { capture: true });
                    }

                }, 100);
            };

            if (document.readyState === 'loading') {
                if (typeof document.addEventListener === 'function') {
                    document.addEventListener('DOMContentLoaded', initRobustCart);
                }
            } else {
                initRobustCart();
            }

            // Tooltip
            if (typeof document.body.addEventListener === 'function') {
                document.body.addEventListener('mouseover', (e) => {
                    if (e.target && e.target.classList && e.target.classList.contains('rf-tooltip-trigger')) {
                        this.showTooltip(e.target);
                    }
                });
                document.body.addEventListener('mouseout', (e) => {
                    if (e.target && e.target.classList && e.target.classList.contains('rf-tooltip-trigger')) {
                        this.hideTooltip();
                    }
                });

                // Info Popover Logic (Delegated)
                document.body.addEventListener('click', (e) => {
                    // 1. Trigger Logic
                    const trigger = e.target && typeof e.target.closest === 'function' ? e.target.closest('.rf-info-trigger') : null;
                    if (trigger) {
                        // Desktop Check: Prevent JS click on PC (Hover only)
                        if (window.innerWidth > 768) return;
                        e.preventDefault();
                        e.stopPropagation();
                        console.log("ℹ️ RF: Info Trigger Clicked (Mobile)");

                        const popover = this.container.querySelector('#rf-info-modal-global');

                        if (popover) {
                            // Check visibility (flex or block just in case)
                            const isVisible = popover.style.display === 'flex' || popover.style.display === 'block';

                            if (!isVisible) {
                                // Fix: Set 'flex' immediately so centering works
                                popover.style.display = 'flex';
                                requestAnimationFrame(() => {
                                    popover.classList.add('rf-active');
                                });
                            } else {
                                // Instant Close (User Requested)
                                popover.classList.remove('rf-active');
                                popover.style.display = 'none';
                            }
                        }
                        return;
                    }

                    // 2. Close Button Logic
                    const closeBtn = e.target.closest('.rf-popover-close-btn');
                    if (closeBtn) {
                        e.preventDefault();
                        const popover = closeBtn.closest('.rf-info-popover');
                        if (popover) {
                            popover.classList.remove('rf-active');
                            popover.style.display = 'none';
                        }
                        return;
                    }

                    // 3. Backdrop Click Logic (Global Modal)
                    const globalModal = this.container.querySelector('#rf-info-modal-global');
                    // Check against flex as well
                    if (globalModal && (globalModal.style.display === 'block' || globalModal.style.display === 'flex')) {
                        // If click target IS the backdrop container (not child), close it
                        if (e.target === globalModal) {
                            e.preventDefault();
                            console.log("ℹ️ RF: Backdrop Clicked");
                            globalModal.classList.remove('rf-active');
                            globalModal.style.display = 'none';
                        }
                    }
                });

            }
        }

        initHelperModal() {
            const btn = this.container.querySelector('#rf-layout-help-btn');
            const modal = this.container.querySelector('#rf-layout-modal');
            if (btn && modal && typeof btn.addEventListener === 'function' && typeof modal.addEventListener === 'function') {
                // Open
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (modal.style) modal.style.display = 'flex';
                    // Small delay to allow display:flex to apply before opacity transition
                    requestAnimationFrame(() => {
                        if (modal.classList) modal.classList.add('rf-active');
                    });
                });

                // Close on Backdrop Click OR Close Button Click (Delegation)
                modal.addEventListener('click', (e) => {
                    // 1. Backdrop Click
                    if (e.target === modal) {
                        e.preventDefault();
                        modal.classList.remove('rf-active');
                        setTimeout(() => { modal.style.display = 'none'; }, 300);
                        return;
                    }

                    // 2. Close Button Click (Delegation)
                    const closeBtnIn = e.target.closest('#rf-layout-modal-close') || e.target.closest('.rf-modal-close');
                    if (closeBtnIn) {
                        e.preventDefault();
                        modal.classList.remove('rf-active');
                        setTimeout(() => { modal.style.display = 'none'; }, 300);
                    }
                });
            }
        }


        async handleRobustSubmit(e) {
            if (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
            console.log("RF: Submit Clicked");

            if (this.isSubmitting) {
                console.warn("RF: Skipped - Already submitting");
                return;
            }

            // 1. Validate Custom Form
            if (!this.validateForm()) {
                console.log("RF: Validation Failed");
                this.isSubmitting = false; // Reset lock if validation fails
                return false;
            }

            // [FIX #P30546] Block Submission if Uploads Pending
            // [FIX ST-47 2026-07-31] 入稿UIを持たないフォーム (simple_buy = 用紙サンプル帳 / 全用紙サンプル) では
            // this.elements.fileList が存在しない。素の参照は TypeError で送信ごと落ちる (石黒報告: ボタン無反応)。
            const uploadingItems = this.elements.fileList ? this.elements.fileList.querySelectorAll('.rf-file-item:not(.rf-upload-complete):not(.rf-error)') : [];
            if (uploadingItems.length > 0) {
                alert("ファイルのアップロード中です。完了するまでお待ちください。");
                this.isSubmitting = false;
                return false;
            }
            // Also check for errors?
            const errorItems = this.elements.fileList ? this.elements.fileList.querySelectorAll('.rf-file-item.rf-error') : [];
            if (errorItems.length > 0) {
                alert("エラーが発生したファイルがあります。削除してから注文してください。");
                this.isSubmitting = false;
                return false;
            }

            // Ensure hidden inputs are up to date
            this.updateHiddenFilesInput();

            // [NEW] Validate File Quantities (Async)
            // We await the result because it might show a modal
            const qtyValid = await this.validateTotalQuantity(null, true);
            if (!qtyValid) {
                console.log("RF: Quantity Validation Failed/Cancelled");
                this.isSubmitting = false; // Reset lock
                return false;
            }

            this.isSubmitting = true;
            const btn = this.container.querySelector('.rf-btn-add-to-cart');
            if (btn) {
                btn.textContent = '処理中...';
                btn.disabled = true;
            }

            const form = this.container.closest('form');

            // 2. Prepare Payload (Manual Construction)
            setTimeout(() => {
                try {
                    const formData = new FormData(form);
                    const payload = {};
                    for (let [key, value] of formData.entries()) {
                        payload[key] = value;
                    }

                    let hiddenJSON = {};
                    try {
                        hiddenJSON = JSON.parse(payload['properties[_acpaHidden]']);
                    } catch (e) {
                        // console.log('RF: _acpaHidden parse failed', e);
                    }

                    // Create a clean form for submission
                    const cleanForm = document.createElement('form');
                    cleanForm.method = 'POST';
                    cleanForm.action = '/cart/add';
                    cleanForm.style.display = 'none';

                    const appendInput = (name, value) => {
                        const inp = document.createElement('input');
                        inp.type = 'hidden';
                        inp.name = name;
                        inp.value = value;
                        cleanForm.appendChild(inp);
                    };

                    // Copy Basic inputs (Quantity, Variant ID, etc.)
                    for (let [key, val] of formData.entries()) {
                        if (!key.startsWith('properties[')) {
                            appendInput(key, val);
                        }
                    }

                    // Prepare Properties
                    const propertiesToSend = {};
                    const acoCompatibility = { "_acoValidationDone": "true" };

                    // Process JSON to populate properties and compatibility map
                    // We trust the JSON structure from Aco but ensure our values are reflected
                    for (const key in hiddenJSON) {
                        const item = hiddenJSON[key];
                        if (item.label) {
                            let val = item.value;

                            // Handle array values safely
                            if (Array.isArray(item._value)) {
                                if (item._value.length === 0) {
                                    // Default fallback for empty specific fields
                                    if (item.label.includes('ファイル') || item.label.includes('入稿') || item.label.includes('レイアウト')) {
                                        val = "なし";
                                        item._value = ["なし"];
                                        item.value = "なし";
                                    } else {
                                        val = "";
                                    }
                                } else {
                                    val = item._value.join(',');
                                }
                            }

                            if (!val && (item.label.includes('ファイル') || item.label.includes('入稿'))) {
                                val = "なし";
                            }

                            if (val !== undefined && val !== null && val !== "") {
                                // CLEANUP: Prevent resurrection of legacy/duplicate keys
                                if (item.label === '入稿ファイル情報' || item.label === 'ファイルアップロード' || item.label === '入稿データURL') continue;

                                propertiesToSend[item.label] = val;
                                acoCompatibility[item.label] = val;
                            }
                        }
                    }

                    // Standardize Custom Field Values (Overwrite with actual selections)

                    // Layout Confirmation
                    const myConfirm = this.container.querySelector('input[name="properties[レイアウト確認]"]');
                    if (myConfirm) {
                        const confirmVal = myConfirm.checked ? '希望する' : '希望しない';
                        propertiesToSend['レイアウト確認'] = confirmVal;
                        // Update JSON metadata for consistency
                        const jsonConfirmItem = Object.values(hiddenJSON).find(i => i.label === 'レイアウト確認');
                        if (jsonConfirmItem) {
                            jsonConfirmItem.value = confirmVal;
                            jsonConfirmItem._value = [confirmVal];
                        }
                    }

                    // File Upload Name & URL
                    const myFileForCheck = this.container.querySelector('input[name="properties[入稿ファイル名]"]');
                    const myFileUrlInput = this.container.querySelector('#rf-file-urls');

                    const finalFName = myFileForCheck?.value || "なし";
                    const finalFUrl = myFileUrlInput?.value || "";

                    // Google Drive Integration & Admin Link Support
                    // REVISED: Unification to "ファイルアップロード" (Visible) only.

                    if (finalFUrl) {
                        // A. Clean URL for internal use (GAS / Thumbnails)
                        // Remove quotes if present
                        const cleanUrl = finalFUrl.replace(/['"]+/g, '');

                        // Visible Property: Admin UI
                        // User requested Split Properties: "ファイルアップロード1", "ファイルアップロード2"...

                        const urlList = cleanUrl.split(',').map(u => u.trim()).filter(u => u);
                        if (urlList.length === 1) {
                            // If only 1 file, keep simple "ファイルアップロード" (or "1" if preferred? User showed "1" in list)
                            // The request showed logic for multiple. 
                            // Let's stick to "ファイルアップロード" for single, and numbered for multiple?
                            // "変更後: ファイルアップロード1..." implies strictly numbered.
                            // Let's use numbered always for consistency with the request.
                            propertiesToSend['ファイルアップロード1'] = urlList[0];
                        } else {
                            urlList.forEach((u, i) => {
                                propertiesToSend[`ファイルアップロード${i + 1}`] = u;
                            });
                        }
                        // Remove the old aggregate key
                        delete propertiesToSend['ファイルアップロード'];
                    }

                    // C. Explicitly Delete Duplicate/Fluctuating Keys
                    delete propertiesToSend['入稿データURL'];
                    delete propertiesToSend['入稿ファイル情報'];
                    delete propertiesToSend['_入稿データURL']; // Strict Removal per Request

                    // Aggressive Cleanup: Remove any other key that looks like a URL duplicate
                    Object.keys(propertiesToSend).forEach(k => {
                        // Allow "ファイルアップロード" or "ファイルアップロード1", "2"...
                        const isAllowed = k === 'ファイルアップロード' || k.match(/^ファイルアップロード\d+$/);

                        if ((k.includes('入稿データURL') || k.includes('ファイルアップロード')) && !isAllowed) {
                            delete propertiesToSend[k];
                        }
                    });


                    // Update hidden JSON metadata
                    const jsonFileItem = Object.values(hiddenJSON).find(i => i.label && (i.label.includes('ファイルアップロード') || i.label.includes('入稿')));
                    if (jsonFileItem) {
                        jsonFileItem.value = finalFName;
                        jsonFileItem._value = [finalFName];
                    }

                    // --- CRITICAL FIX 3: PREVENT DOUBLE JSON ENCODING ---
                    // User reported values like "\"Value\"". This happens if we double-stringify or if hiddenJSON contained strings.
                    // We trust "safeSet" and manual assignments, but verify everything before send.

                    Object.keys(propertiesToSend).forEach(key => {
                        let val = propertiesToSend[key];

                        // 1. If it's an array, join it (Standardize to comma-separated string)
                        if (Array.isArray(val)) {
                            propertiesToSend[key] = val.join(', ');
                        }
                        // 2. If it's a string looking like a JSON string ("..."), try to unwrap it
                        else if (typeof val === 'string') {
                            // Check if it looks like a JSON stringified string
                            if (val.startsWith('"') && val.endsWith('"')) {
                                try {
                                    const parsed = JSON.parse(val);
                                    // If parsing gives us a logical value (string/number), use it
                                    if (typeof parsed === 'string' || typeof parsed === 'number') {
                                        propertiesToSend[key] = parsed;
                                    }
                                } catch (e) {
                                    // Not valid JSON, keep original
                                }
                            }
                        }
                    });

                    // --- CRITICAL FIX 2: FORCE COLLECT Custom UI Properties via DOM ---
                    // FormData sometimes misses dynamic inputs or those with complex visibility. 
                    // We manually grab known critical keys to be 100% sure.

                    const safeSet = (key, val) => {
                        // [Fix] Ensure we don't accidentally stringify arrays or objects here
                        if (val === undefined || val === null) return;

                        let finalVal = val;
                        if (Array.isArray(val)) {
                            finalVal = val.join(', ');
                        } else if (typeof val === 'object') {
                            // Should not happen for simple props, but just in case
                            // If it's an object, we might want to keep it or stringify it?
                            // User wants Clean Strings.
                            // Assuming simple toString or avoid objects.
                            return; // Skip complex objects for "safeSet"
                        }

                        if (finalVal.toString().trim() !== "") {
                            propertiesToSend[key] = finalVal;
                        }
                    };

                    // 1. Size
                    const sizeMode = document.querySelector('input[name="rf-size-mode"]:checked')?.value;
                    if (sizeMode === 'standard') {
                        safeSet('印刷サイズ', this.elements.sizeSelect.value);
                    } else if (sizeMode === 'custom') {
                        const shorts = this.container.querySelector('#rf-size-short').value;
                        const longs = this.container.querySelector('#rf-size-long').value;
                        if (shorts && longs) safeSet('印刷サイズ', `定形外サイズ: ${shorts}x${longs}mm`);
                    }

                    // 2. Layout
                    const layoutRadio = document.querySelector('input[name="properties[印刷レイアウト]"]:checked');
                    const layout = layoutRadio?.value;
                    const layoutType = layoutRadio?.dataset?.layout;
                    safeSet('印刷レイアウト', layout);

                    // 3. Layout Options
                    if (layoutType === 'borderless') {
                        const blCheck = this.container.querySelector('#rf-check-borderless');
                        if (blCheck && blCheck.checked) safeSet('画像の周囲が数mmカットされることを了承しました', '了承');
                    }
                    if (layoutType === 'border') {
                        const marginType = document.querySelector('input[name="properties[フチ処理]"]:checked')?.value;
                        safeSet('フチ処理', marginType);

                        // Margin Details
                        // Margin Details
                        if (marginType === 'フチ幅指定') {
                            // REVISED logic: Unified "フチ幅" string, removal of individual keys.
                            // Format: "フチ幅: 上XXmm, 下XXmm..."
                            // Empty = "指定なし", 0 = "0mm"

                            const mTop = this.container.querySelector('#rf-margin-top').value;
                            const mBottom = this.container.querySelector('#rf-margin-bottom').value;
                            const mLeft = this.container.querySelector('#rf-margin-left').value;
                            const mRight = this.container.querySelector('#rf-margin-right').value;

                            const formatM = (v) => (v === "" || v === undefined) ? "指定なし" : v + "mm";

                            const tStr = `上${formatM(mTop)}`;
                            const bStr = `下${formatM(mBottom)}`;
                            const lStr = `左${formatM(mLeft)}`;
                            const rStr = `右${formatM(mRight)}`;

                            safeSet('フチ幅', `${tStr}, ${bStr}, ${lStr}, ${rStr}`);

                            // Explicitly remove individual property keys to prevent duplication in Cart
                            // (In case logic elsewhere or formData picked them up)
                            if (propertiesToSend['フチ幅(上)']) delete propertiesToSend['フチ幅(上)'];
                            if (propertiesToSend['フチ幅(下)']) delete propertiesToSend['フチ幅(下)'];
                            if (propertiesToSend['フチ幅(左)']) delete propertiesToSend['フチ幅(左)'];
                            if (propertiesToSend['フチ幅(右)']) delete propertiesToSend['フチ幅(右)'];

                        } else if (marginType === '画像サイズ指定') {
                            const mSize = document.querySelector('input[name="properties[画像サイズ]"]')?.value;
                            if (mSize) safeSet('画像サイズ', mSize);
                        }
                    }
                    if (layout === '完全データ入稿') {
                        const dCheck1 = this.container.querySelector('#rf-check-data-no-resize');
                        if (dCheck1 && dCheck1.checked) safeSet('データそのまま印刷了承', '了承');

                        const dCheck2 = this.container.querySelector('#rf-check-data-margin');
                        if (dCheck2 && dCheck2.checked) safeSet('完全データ余白3mm了承', '了承');
                    }

                    // 4. Common Options
                    const confirmCheck = this.container.querySelector('input[name="properties[レイアウト確認]"]:checked');
                    if (confirmCheck) safeSet('レイアウト確認', '希望する');

                    const remarks = document.querySelector('textarea[name="properties[データに関する備考]"]')?.value;
                    if (remarks) safeSet('データに関する備考', remarks);

                    // [NEW] Frame Color
                    const selectedColorInput = document.querySelector('input[name="properties[フレームカラー]"]:checked, input[name="properties[側面カラー]"]:checked, input[name="properties[テープカラー]"]:checked, input[name="properties[側面テープカラー]"]:checked');
                    if (selectedColorInput) {
                        const attrName = selectedColorInput.name.match(/\[(.*?)\]/)[1];
                        safeSet(attrName, selectedColorInput.value);
                    }

                    // [NEW] Mat Color
                    const matColorGroup = document.getElementById('rf-mat-color-group');
                    if (matColorGroup && matColorGroup.offsetParent !== null) {
                        const matColor = document.querySelector('input[name="properties[マットカラー]"]:checked')?.value;
                        if (matColor) safeSet('マットカラー', matColor);
                    }

                    // [NEW] Paper Type & Size
                    // [2026-06-22] #rf-paper-select の option.value=handle(英語 例 claessens-whitematte-canvas)。
                    // カート/注文/問い合わせメールには **表示テキスト(日本語タイトル)** を保存する
                    // (価格/在庫ロジックは value=handle を別途使用するため value 自体は変えない)。
                    const _paperSel = this.container.querySelector('#rf-paper-select');
                    if (_paperSel && _paperSel.value) {
                        const _paperOpt = (_paperSel.selectedIndex >= 0) ? _paperSel.options[_paperSel.selectedIndex] : null;
                        const paperType = (_paperOpt && (_paperOpt.textContent || '').trim()) || _paperSel.value;
                        safeSet('用紙種類', paperType);
                    }

                    const paperSizeSelect = this.container.querySelector('#rf-paper-size-select');
                    if (paperSizeSelect && paperSizeSelect.value) {
                        const selectedOption = paperSizeSelect.options[paperSizeSelect.selectedIndex];
                        safeSet('用紙サイズ', selectedOption.value);
                    }

                    // [NEW] Window Size
                    const winShort = this.container.querySelector('#rf-window-short')?.value;
                    const winLong = this.container.querySelector('#rf-window-long')?.value;
                    if (winShort && winLong) safeSet('窓抜きサイズ', `${winShort}x${winLong}mm`);


                    // --- Merge remaining FormData (for safety) ---
                    for (let [key, val] of formData.entries()) {
                        if (key.startsWith('properties[')) {
                            const match = key.match(/properties\[(.*?)\]/);
                            if (match && match[1]) {
                                const label = match[1];
                                if (label.startsWith('_') || label === 'acpa_id') continue;
                                if (!propertiesToSend[label]) { // Only add if not already manually set
                                    if (val && val.toString().trim() !== "") {
                                        propertiesToSend[label] = val;
                                    }
                                }
                            }
                        }
                    }

                    // --- Final Cleanup to prevent fluctuation ---
                    delete propertiesToSend['入稿データURL'];
                    delete propertiesToSend['入稿ファイル情報'];

                    // CLEANUP: If Standard Mode, prevent custom dimensions from persisting in Cart
                    if (sizeMode === 'standard') {
                        if (propertiesToSend['縦(mm)']) delete propertiesToSend['縦(mm)'];
                        if (propertiesToSend['横(mm)']) delete propertiesToSend['横(mm)'];
                    }

                    // [FIX #P30542] Cleanup Image Size inputs if not relevant
                    // Only keep them if layout is 'フチあり' AND marginType is '画像サイズ指定'
                    const currentLayoutRadio = document.querySelector('input[name="properties[印刷レイアウト]"]:checked');
                    const currentLayoutType = currentLayoutRadio?.dataset?.layout;
                    const currentMarginType = document.querySelector('input[name="properties[フチ処理]"]:checked')?.value;

                    if (currentLayoutType !== 'border' || currentMarginType !== '画像サイズ指定') {
                        if (propertiesToSend['画像サイズ(横)']) delete propertiesToSend['画像サイズ(横)'];
                        if (propertiesToSend['画像サイズ(縦)']) delete propertiesToSend['画像サイズ(縦)'];
                    }

                    // --- Test Print Item Properties ---
                    if (this.elements.testPrintCheck && this.elements.testPrintCheck.checked && this.testPrintVariantId) {
                        const tpQty = parseInt(this.elements.testPrintQtyInput.value) || 1;

                        // REVISED: Dynamic Filename Collection
                        // [FIX] 空セレクタ querySelectorAll('') は無効で SyntaxError を throw し、
                        // テストプリント有効時のカート追加が必ず失敗していた。動的生成のファイル名入力(.rf-tp-file-input)を拾う。
                        const tpFilename = Array.from(this.container.querySelectorAll('.rf-tp-file-input'))
                            .map(inp => inp.value)
                            .filter(v => v && v.trim() !== '')
                            .join(', ') || "指定なし";

                        const tpAddress = this.elements.testPrintAddress.value;

                        // Append properties for the main product indicating test print details
                        safeSet('テストプリントファイル名', tpFilename);
                        safeSet('テストプリント送付先住所', tpAddress);
                        safeSet('テストプリント数量', tpQty);

                        // If the theme/Shopify setup supports adding multiple items via form submission,
                        // we would need to create a separate set of inputs for the test print product.
                        // For now, we'll add its properties to the main product's properties.
                        // If a separate line item is desired, this would require an AJAX cart API call.
                        // Given the current structure, we'll attach test print details as properties to the main item.
                    }


                    // --- CRITICAL FIX 3: SYNC TO ACO HIDDEN JSON ---
                    // Some themes/apps ignore standard properties if Aco is active.
                    // We inject our custom properties into Aco's hidden storage to force them to persist.
                    const timestamp = Date.now();
                    let counter = 0;

                    for (const [key, val] of Object.entries(propertiesToSend)) {
                        // Using loop to catch everything collected by safeSet
                        // [FIX] Allow custom underscore properties (like _ダウンロード) to be added to hiddenJSON so Aco preserves them
                        if (key === '_acpaHidden' || key === '_acoCompatibility' || key === '_acoValidationDone') continue;

                        // Check if this label already exists in hiddenJSON
                        let existingKey = Object.keys(hiddenJSON).find(k => hiddenJSON[k].label === key);

                        if (existingKey) {
                            hiddenJSON[existingKey].value = val;
                            hiddenJSON[existingKey]._value = [val];
                        } else {
                            // Create new entry mimicking Aco structure
                            const newKey = `custom_${timestamp}_${counter++}`;
                            hiddenJSON[newKey] = {
                                label: key,
                                value: val,
                                _value: [val],
                                type: 'text'
                            };
                        }
                        // Also sync to compatibility map
                        acoCompatibility[key] = val;
                    }

                    // Update the JSON strings
                    const finalAcpaHidden = JSON.stringify(hiddenJSON);
                    const finalAcoCompatibility = JSON.stringify(acoCompatibility);

                    // Add Aco Hidden Fields to properties
                    propertiesToSend['_acpaHidden'] = finalAcpaHidden;
                    propertiesToSend['_acoCompatibility'] = finalAcoCompatibility;
                    propertiesToSend['_acoValidationDone'] = 'true';

                    // --- CRITICAL: Reorder Properties for Admin/Cart Display ---
                    const orderList = [
                        '印刷サイズ',
                        '縦(mm)', '横(mm)',
                        '印刷レイアウト',
                        'フチ処理',
                        'フチ幅',
                        '画像サイズ(横)', '画像サイズ(縦)',
                        '画像の周囲が数mmカットされることを了承しました',
                        'データそのまま印刷了承', '完全データ余白3mm了承',
                        'レイアウト確認',
                        'フレームカラー', // [NEW]
                        '側面カラー',
                        'テープカラー',
                        '側面テープカラー',
                        'マットカラー', // [NEW]
                        '用紙種類', // [NEW]
                        '用紙サイズ', // [NEW]
                        '窓抜きサイズ', // [NEW]
                        'テストプリント',
                        'テストプリント数量', 'テストプリントファイル名', 'テストプリント送付先住所',
                        '入稿ファイル名',
                        'データに関する備考',
                        '備考欄',
                        'ファイルアップロード'
                    ];

                    const orderedProps = {};
                    // 1. Add keys in preferred order
                    orderList.forEach(key => {
                        if (Object.prototype.hasOwnProperty.call(propertiesToSend, key)) {
                            orderedProps[key] = propertiesToSend[key];
                            delete propertiesToSend[key];
                        }
                    });
                    // 2. Add remaining keys (including hidden _acpaHidden etc.)
                    Object.keys(propertiesToSend).forEach(key => {
                        orderedProps[key] = propertiesToSend[key];
                    });

                    // --- Construct Items for AJAX Submission ---
                    const items = [];
                    const mainVariantId = this.container.closest('form').querySelector('input[name="id"]').value;
                    const bundleId = `bundle_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
                    orderedProps['_bundle_id'] = bundleId;
                    orderedProps['_bundle_type'] = 'main'; // [NEW] Identify as Parent

                    items.push({
                        id: parseInt(mainVariantId),
                        quantity: parseInt(this.elements.qtyInput.value) || 1,
                        properties: orderedProps
                    });

                    // [NEW] Add Paper Variant if selected (for Overmat/Bookmat)
                    const paperSelect = this.container.querySelector('#rf-paper-size-select');
                    if (paperSelect && paperSelect.value && !paperSelect.closest('.rf-hidden')) {
                        // Assuming value is Variant ID or we need to find it?
                        // If value is name, we need to map to ID.
                        // But Implementation Plan v2 said "Inject Paper Variant data".
                        // Let's assume for now paperSelect.value MIGHT be the ID if setup correctly, 
                        // OR we need to find the ID from rfConfig.paperData based on name.
                        // Let's grab the ID from the selected option's dataset if available.
                        const selectedOption = paperSelect.options[paperSelect.selectedIndex];
                        const paperVariantId = selectedOption.dataset.id || paperSelect.value;

                        if (paperVariantId && !isNaN(parseInt(paperVariantId))) {
                            items.push({
                                id: parseInt(paperVariantId),
                                quantity: parseInt(this.elements.qtyInput.value) || 1,
                                properties: {
                                    '_bundle_id': bundleId,
                                    'Main Product': this.productData.title,
                                    'Paper Size': selectedOption.text
                                }
                            });
                            console.log("RF: Added Paper Bundle Item", paperVariantId);
                        }
                    }

                    // Test Print Item
                    if (this.elements.testPrintCheck && this.elements.testPrintCheck.checked && this.testPrintVariantId) {
                        items.push({
                            id: parseInt(this.testPrintVariantId),
                            quantity: parseInt(this.elements.testPrintQtyInput.value) || 1,
                            properties: {
                                "_RelatedProduct": "Test Print",
                                "main_product": this.productData.title || "Main Product",
                                "_bundle_id": bundleId,
                                // [FIX] 空セレクタ querySelectorAll('') は無効で例外 → ATC 失敗。.rf-tp-file-input を拾う。
                                "ファイル名": Array.from(this.container.querySelectorAll('.rf-tp-file-input'))
                                    .map(inp => inp.value)
                                    .filter(v => v && v.trim() !== '')
                                    .join(', ') || "指定なし",
                                "送付先住所": this.elements.testPrintAddress.value
                            }
                        });
                    }

                    // Prepare Payload (renamed to avoid conflict)
                    const cartPayload = { items: items };

                    // [FIX] Detect Cart Drawer Section ID
                    const drawerEl = document.querySelector('cart-drawer');
                    let drawerSectionId = null;
                    if (drawerEl) {
                        const sectionContainer = drawerEl.closest('.shopify-section');
                        if (sectionContainer) {
                            drawerSectionId = sectionContainer.id.replace('shopify-section-', '');
                            cartPayload.sections = drawerSectionId;
                            cartPayload.sections_url = window.location.pathname;
                        }
                    }

                    // Execute AJAX Request
                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(cartPayload)
                    })
                        .then(async response => {
                            const data = await response.json();

                            this.isSubmitting = false; // Always reset first

                            // Reset Button
                            if (btn) {
                                this.restoreAddToCartLabel(btn);
                                btn.disabled = false;
                            }

                            if (data.status === 422) {
                                console.error("🛒 RF: Cart Add Error", data);
                                // [2026-06-19] ⑤類似(在庫切れ+販売停止 variant を選べてしまう)の再発防止・
                                // 全フォーム共通のリアルタイム最終防衛線。wood_panel 等 variant 在庫が JS に
                                // 渡る非 unified フォームは updateAvailableColors で proactive に色を隠すが、
                                // unified 額装(variant JSON に在庫情報なし)や旧/派生 SKU では在庫切れ色を
                                // 選べる余地が残る。Shopify は在庫切れ+DENY を 422 で弾くため、ここで在庫切れを
                                // 判定して「別のサイズ/カラーを選んでください」と明示し、silent/不親切な失敗を防ぐ。
                                const desc = String(data.description || data.message || '');
                                const isSoldOut = /在庫|品切|sold[\s-]?out|out of stock|購入できません|販売を(終了|停止)|in your cart/i.test(desc);
                                if (isSoldOut) {
                                    alert("申し訳ございません。選択された組み合わせ（サイズ・カラー等）は現在お取り扱いできません。\nお手数ですが、別のサイズまたはカラーをお選びください。");
                                } else {
                                    alert("カートへの追加に失敗しました。\n" + (desc || "必須項目を確認してください。"));
                                }
                                return;
                            }

                            console.log("🛒 RF: Added to Cart via AJAX", data);
                            // GA4: フォーム帰属の完了 (標準 add_to_cart は form_type が欠落するため別途)
                            // items = 1回の追加で入った行数。用紙を複数選ぶと1操作で複数行入るので、
                            // これが無いとイベント数ベースのカゴ落ち率が構造的に膨らむ (2026-08-25)。
                            // ⚠️ パラメータ名に `items` を使わないこと。GA4 の標準eコマースでは
                            //    items は「商品の配列」で、そこに数値を入れると解釈が競合する。
                            this._track('rf_add_to_cart', {
                                rf_line_items: Array.isArray(cartPayload.items) ? cartPayload.items.length : 1,
                            });

                            // [FIX] Wrapper Injection for Theme Compatibility
                            if (cartPayload.sections && data.sections && data.sections[cartPayload.sections]) {
                                const sectionId = cartPayload.sections;
                                const innerHTML = data.sections[sectionId];
                                const wrappedHTML = `<div id="shopify-section-${sectionId}" class="shopify-section">${innerHTML}</div>`;
                                data.sections[sectionId] = wrappedHTML;
                            }

                            // [2026-06] /cart/add.js のレスポンスには item_count / total_price が無い。
                            // これを cart:change で渡すとテーマの <cart-dot>/<cart-count> が
                            // item_count=undefined を読み、カートに商品があってもマークが消える。
                            // 完全なカート (/cart.js) から item_count を取得して data に補完する。
                            try {
                                const cartRes = await fetch(window.Shopify.routes.root + 'cart.js', { credentials: 'same-origin' });
                                if (cartRes.ok) {
                                    const fullCart = await cartRes.json();
                                    data.item_count = fullCart.item_count;
                                    data.total_price = fullCart.total_price;
                                }
                            } catch (e) {
                                console.warn('RF: cart.js fetch for item_count failed', e);
                            }

                            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
                                bubbles: true,
                                detail: {
                                    baseEvent: 'variant:add',
                                    cart: data
                                }
                            }));

                            // [FIX 2026-07-28] 投入成功後はフォームをカートから切り離す(新規注文用に戻す)
                            this.resetAfterAddToCart();

                            // 3. Force Open Drawer
                            if (drawerEl) {
                                console.log("🛒 RF: Opening Cart Drawer");
                                if (typeof drawerEl.show === 'function') drawerEl.show();
                                else if (typeof drawerEl.open === 'function') drawerEl.open();
                                else drawerEl.setAttribute('open', 'true');
                            } else {
                                window.location.href = '/cart';
                            }
                        })
                        .catch(error => {
                            console.error('RF: AJAX Error', error);
                            this.isSubmitting = false; // Always reset first
                            if (btn) {
                                this.restoreAddToCartLabel(btn);
                                btn.disabled = false;
                            }
                            alert("通信エラーが発生しました。");
                        });

                } catch (err) {
                    console.error('❌ RF: Logic error', err);
                    alert("エラーが発生しました。");
                    this.isSubmitting = false; // Reset
                    if (btn) {
                        this.restoreAddToCartLabel(btn);
                        btn.disabled = false;
                    }
                }
            }, 300); // Short delay to ensure UI updates
        }



        // ... (handleSizeSelectChange unchanged)

        // ... (updateCustomCalculation unchanged)

        // ... (updateMainVariantId unchanged)

        /**
         * [NEW #P30328] レイアウト確認チェック時に納期テキストを動的変更
         * チェックON: 「ご入金・レイアウト確認完了後」
         * チェックOFF: 「ご入金・データチェック完了後」
         */
        updateShippingPrefixText() {
            const prefixEl = this.container.querySelector('#rf-shipping-prefix');
            if (!prefixEl) return;

            // 出力データ作成オプション = 希望する の場合、レイアウト確認は必須パスなので
            // チェックボックスのクリック状態に関わらず prefix を即座に切り替える
            const captionOptCreate = (this.container && typeof this.container.querySelector === 'function')
                ? this.container.querySelector('input[name="properties[出力データ作成オプション]"]:checked')
                : null;
            const isCaptionCreate = captionOptCreate && captionOptCreate.value === '希望する';

            const layoutConfirmCheck = (this.container && typeof this.container.querySelector === 'function')
                ? this.container.querySelector('input[name="properties[レイアウト確認]"]:checked')
                : null;

            if (isCaptionCreate || layoutConfirmCheck) {
                prefixEl.textContent = 'ご入金・レイアウト確認完了後';
            } else {
                prefixEl.textContent = 'ご入金・データチェック完了後';
            }
        }

        updateTotalDisplay() {
            let oneItemTotal = this.currentBasePrice;

            // [FIX] Add Paper Price
            let paperPrice = 0;
            const paperMode = document.querySelector('input[name="rf-paper-size-mode"]:checked')?.value;

            if (paperMode === 'custom') {
                // Custom: Use the matched variant price
                if (this.selectedPaperCustomVariant && this.selectedPaperCustomVariant.price) {
                    paperPrice = this.selectedPaperCustomVariant.price;
                }
            } else {
                // Standard: Use selected option data-price
                const paperSelect = this.container.querySelector('#rf-paper-size-select');
                if (paperSelect && paperSelect.selectedOptions && paperSelect.selectedOptions.length > 0) {
                    const selectedOpt = paperSelect.selectedOptions[0];
                    const p = selectedOpt.dataset.price;
                    if (p) paperPrice = parseInt(p, 10);
                }
            }

            // [NEW] updateAvailableColors if size is selected (Standard mode only?)
            // Actually, handleSizeSelectChange is where we should call it.
            // But for initial load update, let's check sizeSelect value.
            const sizeMode = document.querySelector('input[name="rf-size-mode"]:checked')?.value;

            // This method (updateTotalDisplay) is called frequently. calling updateAvailableColors here might be redundent or safe.
            // Ideally, updateAvailableColors is called only when SIZE changes. 
            // But let's verify if we need it here.


            // Add to Base Price
            oneItemTotal += paperPrice;

            const qty = parseInt(this.elements.qtyInput.value) || 1;
            let total = oneItemTotal * qty;

            // --- Test Print Calculation ---
            let testPrintTotal = 0;
            if (this.elements.testPrintCheck && this.elements.testPrintCheck.checked) {
                const tpQty = parseInt(this.elements.testPrintQtyInput.value) || 1;
                testPrintTotal = (this.testPrintPrice || 0) * tpQty;
            }

            // --- Volume Discount Logic ---
            // 実 Shopify 自動割引(ボリュームディスカウント)はコレクション限定:
            // タグ 用紙 / キャンバス / 額装加工 / 額縁 を持つ商品のみが対象。対象外商品では割引を出さない。
            // カウントはカートに投入される「対象 line item の数量合計」(額装は印刷行+額装行=2点)で算出し、
            // buildCartItems と同条件(主商品ライン + #rf-paper-size-select の用紙ライン)で実カートと一致させる。
            // SSoT: directive E-PHOTOPRI-OPTFORM-02 / project_photopri_volume_discount_scope
            const RF_DISCOUNT_TAGS = ['用紙', 'キャンバス', '額装加工', '額縁'];
            const rfTags = (this.config.tags || []).map(t => String(t).trim());
            const mainDiscountEligible = rfTags.some(t => RF_DISCOUNT_TAGS.includes(t));
            const paperSel = this.container.querySelector('#rf-paper-size-select');
            const paperLineAdded = !!(paperSel && paperSel.value && !paperSel.closest('.rf-hidden'));
            let discountCount = 0;
            if (mainDiscountEligible) discountCount += qty; // 主商品ライン(用紙 or 額装加工 等)
            if (paperLineAdded) discountCount += qty;        // 別途追加される用紙ライン(額装の2点目)

            let discountRate = 0;
            if (discountCount >= 100) discountRate = 0.15;
            else if (discountCount >= 50) discountRate = 0.13;
            else if (discountCount >= 30) discountRate = 0.12;
            else if (discountCount >= 10) discountRate = 0.10;

            let finalTotal = total; // Base total for main item
            if (discountRate > 0) {
                finalTotal = Math.floor(total * (1 - discountRate));
            }
            finalTotal += testPrintTotal; // Add test print total after main item discount

            if (this.currentBasePrice === 0 && testPrintTotal === 0) {
                const priceEl = this.container.querySelector('#rf-total-price') || this.container.querySelector('#rf-total-amount');
                if (priceEl) {
                    priceEl.textContent = "---";
                } else {
                    console.warn("RF: Price element not found (--- state)");
                }
            } else {
                // Display Logic
                const priceEl = this.container.querySelector('#rf-total-price') || this.container.querySelector('#rf-total-amount');

                // Date Element (User Request)
                const dateEl = this.container.querySelector('#rf-delivery-date');
                if (dateEl) {
                    // If we had date logic here, we'd use it. 
                    // Currently handled by lead-time.js? 
                    // Only LeadTimeCalculator knows the date.
                    // We leave this hook as requested.
                }

                if (priceEl) {
                    if (discountRate > 0) {
                        const originalTotal = oneItemTotal * qty;
                        const discountPercent = Math.round(discountRate * 100);

                        priceEl.innerHTML = `
                    <div class="rf-price-wrapper">
                            <div class="rf-discount-group">
                                <span class="rf-discount-tag">${discountPercent}% OFF</span>
                                <span class="rf-original-price">${this.formatCurrency(originalTotal)}</span>
                            </div>
                            <span class="rf-final-price">${this.formatCurrency(finalTotal)}</span>
                    </div>
                    `;
                    } else {
                        priceEl.textContent = this.formatCurrency(finalTotal);
                    }
                } else {
                    console.warn("RF: Price element not found for update!");
                }
            }

            // [NEW] Sync Visual State
            this.updateVisualState();
        }

        // [NEW] Global Visual State Sync (Ensures .active is always correct)
        // [NEW] Global Visual State Sync (Ensures .active is always correct)
        // [NEW] Progressive Disclosure Logic
        updateProgressiveDisclosure() {
            this._gaFormStart();   // GA4: 初回操作で rf_form_start を一度だけ
            // Get ALL rf-section elements (excluding config-hidden ones)
            // CSS hides sections 2+ by default via sibling combinator
            // JS manages visibility via rf-section-unlocked / rf-locked-progressive
            const sections = Array.from(this.container.querySelectorAll('.rf-section')).filter(s => {
                return !s.classList.contains('rf-content-hidden');
            });

            // [FIX] For framing forms, always show processing type & color sections
            // regardless of whether size has been selected
            const isFramingForm = ['aluminum_unified', 'wood_unified'].includes(this.formType);
            const alwaysVisibleIds = isFramingForm
                ? ['rf-section-processing-type', 'rf-section-color']
                : [];

            let lockNext = false;

            sections.forEach((section, index) => {
                if (index === 0) {
                    // First section: always visible, add unlocked class
                    section.classList.add('rf-section-unlocked');
                    section.classList.remove('rf-locked-progressive');
                    this._gaStep(section);   // GA4: 第1ステップ到達(ファネル母数)
                    lockNext = this.shouldLockNext(section);
                    return;
                }

                // [FIX] Force-unlock sections that should always be visible for this form type
                const sectionId = section.id || '';
                if (alwaysVisibleIds.includes(sectionId)) {
                    const wasLocked = !section.classList.contains('rf-section-unlocked');
                    section.classList.remove('rf-locked-progressive');
                    section.classList.add('rf-section-unlocked');
                    if (wasLocked) {
                        section.classList.add('rf-reveal');
                        section.addEventListener('animationend', () => {
                            section.classList.remove('rf-reveal');
                        }, { once: true });
                    }
                    // Check if THIS section should lock the ones after it
                    this._gaStep(section);   // GA4: 常時表示セクション到達
                    lockNext = this.shouldLockNext(section);
                    return;
                }

                if (lockNext) {
                    // Lock: hide this section
                    section.classList.remove('rf-section-unlocked');
                    section.classList.remove('rf-reveal');
                    section.classList.add('rf-locked-progressive');
                } else {
                    // Unlock: reveal this section
                    const wasLocked = !section.classList.contains('rf-section-unlocked');
                    section.classList.remove('rf-locked-progressive');
                    section.classList.add('rf-section-unlocked');

                    if (wasLocked) {
                        section.classList.add('rf-reveal');
                        section.addEventListener('animationend', () => {
                            section.classList.remove('rf-reveal');
                        }, { once: true });
                    }

                    this._gaStep(section);   // GA4: 順次開放セクション到達
                    lockNext = this.shouldLockNext(section);
                }
            });
        }

        shouldLockNext(section) {
            // First, find which input containers are actually visible (i.e. not in a display:none tab)
            // This prevents us from requiring a Select if the Custom Size tab is active.
            const isVisible = (el) => {
                while (el && el !== section) {
                    if (window.getComputedStyle(el).display === 'none') return false;
                    el = el.parentElement;
                }
                return true;
            };

            // 1. Selects
            const selects = Array.from(section.querySelectorAll('select:not([disabled])')).filter(isVisible);
            if (selects.length > 0) {
                const isSelected = selects.some(s => s.value && s.value.trim() !== '');
                if (!isSelected) return true; // Lock if no valid selection
            }

            // 2. Radios (Ignore Mode Switchers)
            const radios = Array.from(section.querySelectorAll('input[type="radio"]:not([disabled])'))
                .filter(r => !r.name.includes('-mode') && isVisible(r.parentElement));
            
            if (radios.length > 0) {
                const isChecked = radios.some(r => r.checked);
                if (!isChecked) return true;
            }

            // 3. Custom Text / Number Inputs
            const textInputs = Array.from(section.querySelectorAll('input[type="number"]:not([disabled]), input[type="text"]:not([disabled])'))
                .filter(i => isVisible(i));
            if (textInputs.length > 0) {
                const isFilled = textInputs.some(i => i.value && i.value.trim() !== '' && Number(i.value) > 0);
                if (!isFilled) return true;
            }

            // 4. Required Checkboxes
            const checkboxes = Array.from(section.querySelectorAll('input[type="checkbox"][required]:not([disabled])'))
                .filter(i => isVisible(i.parentElement));
            if (checkboxes.length > 0) {
                const allChecked = checkboxes.every(c => c.checked);
                if (!allChecked) return true; // Lock if ANY visible required checkbox is unticked
            }

            return false;
        }
        updateVisualState() {
            this.updateProgressiveDisclosure();
            const root = this.elements?.form || this.container || document;
            // Find all radio inputs in the form
            const radios = (root && typeof root.querySelectorAll === 'function')
                ? root.querySelectorAll('input[type="radio"]')
                : [];
            let checkedCount = 0;
            if (radios.forEach) {
                radios.forEach(radio => {
                    // Find parent card or pill
                    const parent = (typeof radio.closest === 'function') ? radio.closest('.rf-radio-card, .rf-radio-pill, label') : null;
                    if (parent && parent.classList && typeof parent.classList.add === 'function') {
                        if (radio.checked) {
                            parent.classList.add('active');
                            checkedCount++;
                            // DEBUG
                            // console.log(`RF: Active Radio Found: ${radio.name} = ${radio.value}`);
                        } else {
                            parent.classList.remove('active');
                        }
                    }
                });
            }
            // console.log(`RF: Visual State Updated. Checked Radios: ${checkedCount}`);
        }


        handleSubmit(e) {
            console.log("📝 RF: handleSubmit triggered (Form Submit Event)");
            if (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
            this.handleRobustSubmit(e);
            return false;
        }

        // ... (formatCurrency unchanged)

        // ... (handleLayoutChange logic already updated in thought but code might not be replaced?)
        // Ah, previous chunk was partial. I need to make sure handleLayoutChange logic is actually replaced.
        // The previous tool call modified the constructor and checkInitialLayout.
        // The tool call before that modified handleLayoutChange logic.
        // Let's ensure handleSubmit is updated here.

        validateForm() {
            console.log("RF: Validating form...");
            let isValid = true;
            let firstErrorEl = null;
            // [2026-07-17] 今回の検証で出すエラーを貯め直す。前回分の表示は消す(古い警告を残さない)。
            this._pendingErrors = [];
            this.clearFieldErrors();
            // 検証開始時点で施錠(未到達)だったセクションを記録。既存の各検証は必須項目を
            // 「見つけるために」セクションを解錠してしまうので、後で未到達分を施錠に戻す。
            this._lockedAtStart = new Set();
            this.container.querySelectorAll('.rf-section.rf-locked-progressive').forEach(s => this._lockedAtStart.add(s));

            const registerError = (el, msg = "") => {
                console.warn("RF Validation Failure:", msg, el);
                // [2026-07-17] 400ms の点滅でなく、直るまで残る文言を出す(msg は顧客向け文面)。
                this.showFieldError(el, msg || "こちらの項目をご入力ください");
                isValid = false;
                // Prefer the label or container for scrolling context if possible
                const scrollTarget = el.closest('.rf-section') || el.closest('.rf-input-group') || el;
                if (!firstErrorEl) firstErrorEl = scrollTarget;
            };

            const mode = document.querySelector('input[name="rf-size-mode"]:checked')?.value;
            console.log("RF Validation: Size Mode =", mode);

            // Custom Size Validation
            if (mode === 'standard' && this.elements.sizeSelect.value === '' && this.formType !== 'student_discount') {
                registerError(this.elements.sizeSelect, "サイズを選択してください");
            }
            if (mode === 'custom') {
                if (!this.elements.customShort.value) { registerError(this.elements.customShort, "短辺(mm)をご入力ください"); }
                if (!this.elements.customLong.value) { registerError(this.elements.customLong, "長辺(mm)をご入力ください"); }
                if (this.currentBasePrice === 0) {
                    // If price is 0 but inputs are filled, it's an invalid size combo
                    if (this.elements.customShort.value && this.elements.customLong.value) {
                        registerError(this.elements.customDisplay, "このサイズは対応しておりません。サイズをご確認いただくか、お問い合わせください");
                    }
                }
            }

            // Frame Color Validation
            // [FIX] ID 16: Mandatory Frame Color
            const colorSection = this.container.querySelector('#rf-section-color');
            if (colorSection && !colorSection.classList.contains('rf-content-hidden')) {
                const colorInputs = colorSection.querySelectorAll('input[name="properties[フレームカラー]"], input[name="properties[側面カラー]"], input[name="properties[テープカラー]"], input[name="properties[側面テープカラー]"]');
                if (colorInputs.length > 0) {
                    const colorChecked = Array.from(colorInputs).some(inp => inp.checked);
                    if (!colorChecked) {
                        console.warn("RF Validation Failure: No Frame Color Selected");
                        isValid = false;

                        // Highlight
                        const colorGroup = colorSection.querySelector('.rf-image-group');
                        if (colorGroup) {
                            colorGroup.classList.add('rf-shake');
                            setTimeout(() => colorGroup.classList.remove('rf-shake'), 500);
                        }
                        // [2026-07-17] shake は 500ms で消える=スクロール到着前に合図が無くなる。文言を残す。
                        this.showSectionError(colorSection, "カラーを選択してください",
                            'input[type="radio"], input[type="checkbox"]');
                        colorSection.classList.add('rf-section-unlocked');
                        colorSection.classList.remove('rf-locked-progressive');
                        if (!firstErrorEl) firstErrorEl = colorSection;
                    }
                }
            }

            // Layout Validation
            const layoutSection = this.container.querySelector('#rf-section-layout');
            if (layoutSection && !layoutSection.classList.contains('rf-content-hidden')) {
                let layout = null;
                // Search globally or within container for ANY checked input with this name
                const layoutInputs = this.container.querySelectorAll('input[name="properties[印刷レイアウト]"]');
                layoutInputs.forEach(inp => {
                    if (inp.checked) layout = inp.value;
                });

                console.log("RF Validation: Layout =", layout);

                if (!layout) {
                    // Visual Error Handling
                    layoutInputs.forEach(inp => {
                        const card = inp.closest('.rf-radio-card');
                        if (card) {
                            card.style.borderColor = 'var(--rf-error)';
                            setTimeout(() => card.style.borderColor = '', 1500);
                        }
                    });

                    isValid = false;
                    // [2026-07-17] 枠色は 1500ms で消える=スクロール到着前後で合図が失われる。文言を残す。
                    this.showSectionError(layoutSection, "印刷レイアウト(フチあり/フチなし)を選択してください",
                        'input[name="properties[印刷レイアウト]"]');
                    layoutSection.classList.add('rf-section-unlocked');
                    layoutSection.classList.remove('rf-locked-progressive');
                    // Try to find a scroll target
                    if (!firstErrorEl) firstErrorEl = this.container.querySelector('#rf-section-layout');
                    console.warn("RF Validation Failure: No Layout Selected");
                }

                // Borderless Permission Validation
                const layoutRadio = this.container.querySelector('input[name="properties[印刷レイアウト]"]:checked');
                const layoutType = layoutRadio ? layoutRadio.dataset.layout : null;

                if (layoutType === 'borderless') {
                    const borderCheck = this.container.querySelector('#rf-check-borderless');
                    const isVisible = borderCheck && borderCheck.closest('.rf-section')?.offsetParent !== null;
                    if (borderCheck && isVisible && !borderCheck.checked) {
                        layoutSection.classList.add('rf-section-unlocked');
                        layoutSection.classList.remove('rf-locked-progressive');
                        // [2026-07-17] label[for="rf-check-borderless"] は存在せず null になり、
                        // エラーが無表示のまま submit だけ止まる(サイレント失敗)だった。実チェックボックス基準にする。
                        registerError(borderCheck.closest('label') || borderCheck, "フチなし印刷に関する確認事項にチェックしてください");
                    }
                }

                // [NEW] Photo Card Logo Consent Validation
                const photoCardCheck = this.container.querySelector('#rf-check-photocard-logo');
                const isLogoCheckVisible = photoCardCheck && photoCardCheck.closest('#rf-photo-card-logo-consent')?.style.display !== 'none';
                if (photoCardCheck && isLogoCheckVisible && !photoCardCheck.checked) {
                    const sizeSection = this.container.querySelector('#rf-section-size');
                    if (sizeSection) {
                        sizeSection.classList.add('rf-section-unlocked');
                        sizeSection.classList.remove('rf-locked-progressive');
                    }
                    // [2026-07-17] 同上: label[for=] が無く null 化するので実チェックボックス基準に。
                    registerError(photoCardCheck.closest('label') || photoCardCheck, "ロゴに関する確認事項にチェックしてください");
                }

                // Complete Data Submission Validation
                if (layoutType === 'data') {
                    const checkNoResize = this.container.querySelector('#rf-check-data-no-resize');
                    const checkMargin = this.container.querySelector('#rf-check-data-margin');

                    if (checkNoResize && !checkNoResize.checked) {
                        layoutSection.classList.add('rf-section-unlocked');
                        layoutSection.classList.remove('rf-locked-progressive');
                        registerError(checkNoResize.closest('label') || checkNoResize, "リサイズなしに関する確認事項にチェックしてください");
                    }
                    if (checkMargin && !checkMargin.checked) {
                        layoutSection.classList.add('rf-section-unlocked');
                        layoutSection.classList.remove('rf-locked-progressive');
                        registerError(checkMargin.closest('label') || checkMargin, "余白に関する確認事項にチェックしてください");
                    }
                }
            }

            // [FIX #P30544] Paper Type Validation (Mandatory for Print Only)
            const paperSection = this.container.querySelector('#rf-section-paper');
            if (paperSection && !paperSection.classList.contains('rf-content-hidden')) {
                if (this.elements.paperSelect && (!this.elements.paperSelect.value || this.elements.paperSelect.disabled)) {
                    paperSection.classList.add('rf-section-unlocked');
                    paperSection.classList.remove('rf-locked-progressive');
                    registerError(this.elements.paperSelect, "用紙を選択してください");
                }
            }

            // [NEW] Trial Printing Validation
            if (this.formType === 'otameshi_print') {
                const trialConfirmWrapper = this.container.querySelector('#rf-section-trial-confirm');
                if (trialConfirmWrapper && !trialConfirmWrapper.classList.contains('rf-content-hidden')) {
                    const subCheck = this.container.querySelector('#rf-check-trial-confirm');
                    if (subCheck && !subCheck.checked) {
                        trialConfirmWrapper.classList.add('rf-section-unlocked');
                        trialConfirmWrapper.classList.remove('rf-locked-progressive');
                        registerError(subCheck.closest('label') || subCheck, "確認事項にチェックしてください");
                    }
                }
            }

            // [NEW] Student Discount Validation
            if (this.formType === 'student_discount') {
                if (this.uploadedFiles.length === 0) {
                    registerError(this.elements.dropzone, "学生証データをアップロードしてください");
                }
            }

            // Caption Panel: when 出力データ作成 is requested, the
            // "ご注文確認後、メールにてレイアウト確認のご連絡をお送りいたします…" checkbox is mandatory.
            // Owner spec — operations cannot start before the customer acknowledges the proof flow.
            if (this.formType === 'caption_panel') {
                const captionOptRadio = this.container.querySelector('input[name="properties[出力データ作成オプション]"]:checked');
                const isCreateMode = (captionOptRadio && captionOptRadio.value === '希望する');
                const captionLayout1 = this.container.querySelector('#rf-check-caption-layout-confirm1');
                if (isCreateMode && captionLayout1 && !captionLayout1.checked) {
                    const section = captionLayout1.closest('.rf-section');
                    if (section) {
                        section.classList.add('rf-section-unlocked');
                        section.classList.remove('rf-locked-progressive');
                    }
                    registerError(captionLayout1.closest('label') || captionLayout1, "レイアウト確認に関する項目にチェックしてください");
                }
            }

            // [FIX] Canvas Panel Agreement Validation
            // 「制作上の注意点」セクションの必須チェックボックスを全チェック
            if (this.formType === 'canvas_panel') {
                const canvasAgreementSection = this.container.querySelector('#rf-section-canvas-agreement');
                if (canvasAgreementSection) {
                    const agreementChecks = canvasAgreementSection.querySelectorAll('input[type="checkbox"]');
                    agreementChecks.forEach(cb => {
                        if (!cb.disabled && !cb.checked) {
                            canvasAgreementSection.classList.add('rf-section-unlocked');
                            canvasAgreementSection.classList.remove('rf-locked-progressive');
                            registerError(cb.closest('label') || cb, '制作上の注意点にすべて同意してください');
                            isValid = false;
                        }
                    });
                }
            }

            // [FIX] VPS2026 Agreement Validation
            if (this.formType === 'vps2026') {
                const vpsAgreementSection = this.container.querySelector('#rf-section-vps-agreement');
                if (vpsAgreementSection) {
                    const vpsCheck = vpsAgreementSection.querySelector('input[name="properties[VPS利用規約への同意]"]');
                    // disabledなものはスキップ（分岐で不要になった場合）
                    if (vpsCheck && !vpsCheck.disabled && !vpsCheck.checked) {
                        vpsAgreementSection.classList.add('rf-section-unlocked');
                        vpsAgreementSection.classList.remove('rf-locked-progressive');
                        registerError(vpsCheck.closest('label') || vpsCheck, 'VPS利用規約への同意が必要です');
                        isValid = false;
                    }
                }
            }

            // [FIX] Universal Validation for all required checkboxes
            // 必須項目は非表示状態（プログレッシブディスロージャーの未到達ステップ）であっても突き抜けさせない
            const requiredCheckboxes = this.container.querySelectorAll('input[type="checkbox"][required]');
            requiredCheckboxes.forEach(cb => {
                // disabledになっている項目（選択外のレイアウト分岐など）はスキップ
                if (!cb.disabled) {
                    if (!cb.checked) {
                        // エラー箇所が見えるように非表示セクションを展開する
                        const parentSection = cb.closest('.rf-section');
                        if (parentSection) {
                            parentSection.classList.add('rf-section-unlocked');
                            parentSection.classList.remove('rf-locked-progressive');
                        }
                        
                        const subConditional = cb.closest('.rf-sub-conditional');
                        if (subConditional) {
                            subConditional.style.display = 'block';
                        }
                        
                        // [2026-07-17] 汎用「必須項目です」だと何を直せばよいか分からない。
                        // 所属セクションの見出し(「フチなし設定 *」等)から具体的な文言を作る。
                        registerError(cb.closest('label') || cb, this._requiredCheckboxMessage(cb));
                        isValid = false;
                    }
                }
            });

            // [NEW] Margin Inputs Validation (Respect min attribute)
            const marginInputs = this.container.querySelectorAll('#rf-margin-width-inputs input[type="number"], #rf-margin-size-inputs input[type="number"]');
            marginInputs.forEach(inp => {
                // Check if visible
                if (inp.closest('.rf-sub-conditional') && inp.closest('.rf-sub-conditional').style.display !== 'none' && !inp.checkValidity()) {
                    // [ST-39 2026-07-24] 最小フチ幅は商品(額装/パネル)ごとに min 属性で変わる。
                    // 汎用文言だと「何mm以上なら通るのか」が顧客に伝わらず離脱/問い合わせになるため、
                    // min 違反のときだけ実際の下限値を文面に出す。
                    const minAttr = Number(inp.getAttribute('min'));
                    const val = inp.value;
                    const isUnderMin = inp.closest('#rf-margin-width-inputs') && minAttr > 0
                        && val !== "" && Number(val) < minAttr;
                    registerError(inp, isUnderMin ? `フチ幅は${minAttr}mm以上でご指定ください` : "入力値をご確認ください");
                }
            });

            // Test Print Validation (Disabled: Options are now optional)
            // Code removed to allow empty fields.

            if (!isValid) {
                console.log("RF: Validation Failed. Showing first error only.");
                // [2026-07-17] 貯めた候補のうち画面最上位の1件だけを描画し、そこへ飛ぶ。
                // 未到達セクションまでエラーを撒かない(段階解錠フォームでの正しい挙動)。
                let target = this.renderFirstError() || firstErrorEl;
                // [2026-07-17] 安全網: 検証失敗なのに表示すべきエラーが1件も無い場合(将来の
                // 要素null化バグ等)、無音でブロックしない。購入ボタン近くに汎用文言を必ず出す。
                if (!target) {
                    const anchor = this.elements.addToCartBtn || this.container.querySelector('#rf-add-btn-wrapper') || this.container;
                    const host = (anchor.closest && anchor.closest('.rf-section-content')) || (anchor.parentElement) || this.container;
                    let box = host.querySelector(':scope > .rf-field-error');
                    if (!box) {
                        box = document.createElement('div');
                        box.className = 'rf-field-error';
                        box.setAttribute('role', 'alert');
                        box.style.cssText = 'color:#c0392b;font-size:0.82rem;line-height:1.5;margin-top:0.5rem;font-weight:600;';
                        host.appendChild(box);
                    }
                    box.textContent = '未入力の必須項目があります。ご入力内容をご確認ください';
                    box.style.display = '';
                    target = box;
                }
                // 各検証が未入力探索のために解錠した「未到達」セクションを施錠に戻す
                // (エラーを出す1件を除く)。選択もしていない下流オプションを露出させない。
                const shownSection = target && target.closest ? target.closest('.rf-section') : target;
                if (this._lockedAtStart) {
                    this._lockedAtStart.forEach(sec => {
                        if (sec === shownSection) return;
                        sec.classList.add('rf-locked-progressive');
                        sec.classList.remove('rf-section-unlocked');
                    });
                }
                if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
                console.log("RF: Validation Passed!");
            }


            // [NEW] Photo Card Validation: File Count vs Order Qty
            if (this.formType === 'photo_card') {
                const uploadedCount = this.uploadedFiles.length;
                const orderQty = parseInt(this.elements.qtyInput.value) || 1;

                // Only validate if files are uploaded (if 0, maybe valid if just test print? Assuming files required if not just test print)
                // But usually file upload optional? "File upload: Any".
                // Requirement said: "File count <= Order Qty".
                if (uploadedCount > orderQty) {
                    registerError(this.elements.dropzone, `アップロードファイル数(${uploadedCount})が注文総数(${orderQty})を超えています。`);
                    alert(`アップロードファイル数が注文数を超えています。\n・注文数: ${orderQty}枚\n・アップロード: ${uploadedCount}点\n\nファイルを確認するか、注文数を変更してください。`);
                }
            }

            // [NEW] Validate Glossy Warning Check (Unified)
            const glossyWarningSection = this.container.querySelector('#rf-section-glossy-warning');
            if (glossyWarningSection && !glossyWarningSection.classList.contains('rf-content-hidden') && glossyWarningSection.style.display !== 'none') {
                const glossyCheck = this.container.querySelector('#rf-check-glossy-agree');
                if (glossyCheck && !glossyCheck.checked) {
                    alert('光沢紙の特性について確認し、チェックを入れてください。');
                    glossyWarningSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    return false;
                }
            }

            return isValid;
        }



        updateQuantity(delta) {
            let current = parseInt(this.elements.qtyInput.value) || 1;
            current += delta;
            if (current < 1) current = 1;
            this.elements.qtyInput.value = current;

            // Sync with main form quantity if exists
            const form = this.container.closest('form');
            if (form) {
                const mainQty = form.querySelector('input[name="quantity"]:not(#rf-qty-input)');
                if (mainQty) mainQty.value = current;
            }

            this.updateTotalDisplay();

            // Clear upload errors when quantity changes to allow re-trying upload
            // [FIX ST-47c 2026-07-31] 入稿UIが無いフォーム (simple_buy) には #rf-upload-error が無い。
            // 素の参照で「数量を変えるたびに TypeError」が出ていた (実測: 全用紙サンプル/用紙サンプル帳)。
            // 投入後の resetAfterAddToCart もここを通るため、後続処理がまるごと中断していた。
            if (this.elements.uploadError) this.elements.uploadError.style.display = 'none';
        }

        handleSimpleToggle(show, element) {
            if (!element) return;
            this.toggleContent(element, show);
        }

        updateTestPrintQty(delta) {
            const input = this.elements.testPrintQtyInput;
            if (!input) return;
            let val = parseInt(input.value) || 1;
            val += delta;
            if (val < 1) val = 1;
            input.value = val;

            // Dynamic Filename Inputs Logic
            const wrapper = this.container.querySelector('#rf-tp-filename-wrapper');
            if (wrapper) {
                let inputs = wrapper.querySelectorAll('.rf-tp-file-input');
                let currentCount = inputs.length;

                if (val > currentCount) {
                    for (let i = currentCount + 1; i <= val; i++) {
                        const newInp = document.createElement('input');
                        newInp.type = 'text';
                        newInp.className = 'rf-input rf-tp-file-input';
                        newInp.placeholder = `例: photo_0${i}.jpg (${i}枚目)`;
                        newInp.style.marginBottom = '10px';
                        wrapper.appendChild(newInp);
                    }
                } else if (val < currentCount) {
                    for (let i = currentCount; i > val; i--) {
                        if (wrapper.lastElementChild) {
                            wrapper.removeChild(wrapper.lastElementChild);
                        }
                    }
                }
            }

            this.updateTotalDisplay();
        }

        handleSizeModeChange(e) {
            const mode = e.target.value;
            const isStandard = mode === 'standard';

            if (isStandard) {
                this.elements.standardContainer.style.display = 'block';
                this.elements.customContainer.style.display = 'none';
                this.handleSizeSelectChange({ target: this.elements.sizeSelect });
            } else {
                this.elements.standardContainer.style.display = 'none';
                this.elements.customContainer.style.display = 'block';

                if (this.elements.customShort.value && this.elements.customLong.value) {
                    this.updateCustomCalculation();
                } else {
                    this.currentBasePrice = 0;
                    this.updateTotalDisplay();
                }
                // [FIX] Update Color Options visibility for Custom Mode
                if (typeof this.updateFrameColorOptions === 'function') {
                    this.updateFrameColorOptions();
                }
            }

            // [NEW] Toggle standard size notes visibility
            // 定形外サイズの場合は「定形サイズでオーダー」「2枚納品の料金」注意書きを非表示
            const standardSizeNotes = this.container.querySelector('#rf-standard-size-notes');
            if (standardSizeNotes) {
                standardSizeNotes.style.display = isStandard ? 'block' : 'none';
            }

            // [NEW] モード切替で加工タイプの可否を再評価(定形⇄定形外でゲート基準が変わるため)。
            // 例: 定形 A0 で隠れていたブックマットを、定形外(寸法未入力)に切替えたら再表示する。
            this.updateProcessingTypeAvailability();

            this.updateVisualState(); // Add this line
        }

        // [NEW] Otameshi Print Type (セット/シングル/etc.) — filter paper dropdown to variants matching the chosen type.
        // Selection is RESET on type change so the customer explicitly picks a paper for the new type.
        handleOtameshiTypeChange(selectedType) {
            if (!this.elements.sizeSelect) return;
            if (this.elements.sizeSelect.dataset.otameshiMulti !== 'true') return;

            const select = this.elements.sizeSelect;
            const opts = Array.from(select.options);
            let currentStillValid = false;

            opts.forEach(opt => {
                if (!opt.value) return; // skip placeholder
                const optType = opt.dataset.type || '';
                const matches = optType === selectedType;
                opt.disabled = !matches;
                opt.hidden = !matches;
                if (matches) {
                    if (opt.selected) currentStillValid = true;
                } else if (opt.selected) {
                    opt.selected = false;
                }
            });

            if (!currentStillValid) {
                // Reset to placeholder; customer must pick a paper for the new type
                select.value = '';
                select.dispatchEvent(new Event('change', { bubbles: true }));
            }

            // Toggle the contextual upload note (1セット1データ vs 1枚1データ)
            const isSingleLike = /シングル|単品|1枚|single/i.test(selectedType);
            const noteSet = this.container.querySelector('[data-otameshi-note="set"]');
            const noteSingle = this.container.querySelector('[data-otameshi-note="single"]');
            if (noteSet) noteSet.style.display = isSingleLike ? 'none' : '';
            if (noteSingle) noteSingle.style.display = isSingleLike ? '' : 'none';

            // Owner-requested toggles (set vs single):
            //   - dropdown placeholder text matches the chosen mode
            //   - "このセットに含まれる用紙" breakdown only shows for set
            //   - "初回25%OFF適用へ" link only shows for set
            const placeholder = select.options && select.options[0];
            if (placeholder && placeholder.value === '') {
                placeholder.textContent = isSingleLike ? '用紙を選ぶ' : 'セットを選ぶ';
            }
            if (isSingleLike) {
                const breakdown = document.getElementById('rf-testprint-breakdown');
                if (breakdown) breakdown.style.display = 'none';
            }
            const offLink = document.getElementById('rf-testprint-25off-link');
            if (offLink) offLink.style.display = isSingleLike ? 'none' : '';

            // Surface the selected type to lead-time-calculator via a global event
            document.dispatchEvent(new CustomEvent('otameshi:type-changed', {
                detail: { type: selectedType, isSingle: isSingleLike }
            }));
        }

        // ?variant=<id> で着地したとき、種類ラジオと用紙セレクトを実際に選択済みにする (2026-08-25)
        //
        // 背景: Shopify の ?variant= は隠しフィールド [name="id"] だけを差し替える。
        //   このフォームは用紙を variant でなく properties[用紙] のセレクトで選ぶ構造なので、
        //   隠し値は「シングル/その用紙」なのに画面は既定の「セット・未選択」という
        //   食い違った状態で着地していた (2026-08-25 実機で確認)。
        //   用紙ソムリエ (/pages/paper-sommelier) の結果から送るために、画面側を合わせる。
        //
        // 🔴 ラジオに change を発火させないこと。
        //   _gaUserActed が立つ前に合成 change を撒くと、商品フィード広告の
        //   ?variant= 着地で rf_type_select が誤計上される (ガードを入れた元の事故)。
        //   ラジオは checked を直接立て、絞り込みは handleOtameshiTypeChange を自分で呼ぶ。
        //   セレクトだけは価格・納期の購読者がいるので change を出す
        //   (合成イベントは isTrusted=false なので markActed は素通りする)。
        // 用紙診断から来た着地に、注文まで残る印を1つ付ける (2026-08-25)
        //
        // なぜ cart attribute か:
        //   line item property の `_` 始まりは、この下の送信処理が明示的に捨てている
        //   (`if (label.startsWith('_')) continue;`)。`_` 無しにすると今度は
        //   カート画面に「経由: 用紙診断」と客に見える。cart attribute は注文には
        //   残り、カート/チェックアウトには出ない。
        //
        // ⚠️ 着地時点で打つので、診断経由で来て買わず、後日ふらっと戻って別物を買った
        //    カートにも印が残りうる。判別できるよう診断日を併記し、分析側で
        //    注文日との開きを見て落とせるようにしてある。
        _tagCartSource() {
            try {
                if (new URLSearchParams(window.location.search).get('dx') !== 'sommelier') return;
                // 🔴 このページには /cart/add フォームが2つあり、インスタンスも2つできる
                //    (2026-08-25 実測)。ページ単位で1回に絞らないと同じ POST が二重に飛ぶ。
                if (window.__ppCartSourceTagged) return;
                window.__ppCartSourceTagged = true;
                const d = new Date();
                const ymd = d.getFullYear() + '-'
                    + String(d.getMonth() + 1).padStart(2, '0') + '-'
                    + String(d.getDate()).padStart(2, '0');
                fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ attributes: { '診断経由': '用紙診断', '診断日': ymd } }),
                }).then(r => {
                    // fetch は 4xx/5xx で reject しない。ここを見ないと未付与が黙って流れる。
                    if (!r.ok) {
                        window.__ppCartSourceTagged = false;   // 次の着地で再試行できるよう戻す
                        if (typeof window.gtag === 'function') {
                            window.gtag('event', 'sommelier_tag_failed', { code: r.status });
                        }
                    }
                }).catch(() => {
                    window.__ppCartSourceTagged = false;
                    /* 印が付かなくても購入は通す */
                });
            } catch (e) { /* 着地そのものは壊さない */ }
        }

        _applyVariantPreselect(typeRadios) {
            try {
                const select = this.elements.sizeSelect;
                if (!select || select.dataset.otameshiMulti !== 'true') return;
                const vid = new URLSearchParams(window.location.search).get('variant');
                if (!vid) return;

                const opt = Array.from(select.options)
                    .find(o => o.dataset && o.dataset.id === String(vid));
                if (!opt) return;   // 該当バリアントが選択肢に無い(在庫切れ等) → 既定表示のまま触らない

                const type = opt.dataset.type || '';
                const radios = Array.from(typeRadios || []);
                const radio = radios.find(r => (r.dataset.typeValue || r.value) === type);
                if (radio && !radio.checked) {
                    radios.forEach(r => { r.checked = false; });
                    radio.checked = true;
                }
                this.handleOtameshiTypeChange(type);   // 種類でセレクトを絞り込む

                // value でなく option を直接選ぶ。同名 value が複数あっても取り違えない
                opt.selected = true;
                if (!opt.selected) return;
                select.dispatchEvent(new Event('change', { bubbles: true }));
            } catch (e) { /* 着地そのものは壊さない */ }
        }

        handleSizeSelectChange(e) {
            // ▼▼▼ 修正ポイント: e.target ではなく、常に「保存してあるサイズ選択要素」を見に行く ▼▼▼
            const selectElement = this.elements.sizeSelect;

            if (!selectElement) return;

            const selectedOption = selectElement.options[selectElement.selectedIndex];

            // [NEW] Trial Printing: Check for "All Paper Set"
            if (this.formType === 'otameshi_print') {
                const trialConfirm = this.container.querySelector('#rf-section-trial-confirm');
                if (trialConfirm) {
                    const val = selectedOption ? selectedOption.value : "";
                    if (val && val.includes('【全用紙セット】')) {
                        trialConfirm.style.display = 'block';
                        const checkbox = trialConfirm.querySelector('input[type="checkbox"]');
                        if (checkbox) checkbox.checked = false;
                    } else {
                        trialConfirm.style.display = 'none';
                    }
                }
            }

            // サイズがまだ選択されていない、または空の場合はリセットして終了
            // (加工タイプを先に選んだ場合などはここで止まりますが、それは正常です)
            if (!selectedOption || selectedOption.value === "") {
                console.log("RF: No size selected yet.");
                this.currentBasePrice = 0;
                this.updateTotalDisplay();
                return;
            }

            // [NEW] 選択中サイズに応じて加工タイプを出し分ける(大判ブックマット等、
            // 実在しない組み合わせを選べないようにする)。無効になった選択は解除される。
            // 価格計算(getMainVariantAndPrice)より前に実行し、解除後の状態で価格を確定させる。
            this.updateProcessingTypeAvailability();

            // ▼ 検索ロジック (getMainVariantAndPrice) を呼び出す
            // ここで「現在のサイズ」と「現在の加工タイプ」を組み合わせて検索します
            let mainVariantInfo;
            // [NEW] Otameshi multi-option: each option already carries data-id + data-price for its exact variant
            if (this.formType === 'otameshi_print' && selectElement.dataset.otameshiMulti === 'true' && selectedOption.dataset.id) {
                mainVariantInfo = {
                    id: selectedOption.dataset.id,
                    price: parseInt(selectedOption.dataset.price || '0', 10) || 0
                };
            } else {
                mainVariantInfo = this.getMainVariantAndPrice();
            }

            const price = mainVariantInfo.price;
            const variantId = mainVariantInfo.id;

            console.log(`RF: Size/Type Changed. New Price: ${price}, ID: ${variantId}`);

            this.currentBasePrice = price;

            // [DPI計算用] 寸法情報の取得（変更なし）
            const text = selectedOption.textContent || "";
            let foundDim = null;
            if (typeof STANDARD_SIZE_DICT !== 'undefined') {
                for (const [key, val] of Object.entries(STANDARD_SIZE_DICT)) {
                    if (text.includes(key)) {
                        foundDim = val;
                        break;
                    }
                }
            } else if (this.STANDARD_SIZES) {
                foundDim = this.STANDARD_SIZES[selectedOption.value];
                if (!foundDim) {
                    for (const [key, val] of Object.entries(this.STANDARD_SIZES)) {
                        if (text.includes(key) || selectedOption.value === key) {
                            foundDim = val;
                            break;
                        }
                    }
                }
            }

            this.currentDimensions = foundDim || null;

            this.updateMainVariantId(variantId);
            this.updateTotalDisplay();

            // [NEW] Update Available Colors based on Size
            this.updateAvailableColors(selectedOption.value);

            // [NEW] Update Paper Options based on Size (filter by matching size)
            this.updatePaperTypeOptions();

            // ▼▼▼ 追加: サイズが変わったら用紙サイズ選択肢もフィルタリングし直す ▼▼▼
            if (typeof this.updatePaperSizeOptions === 'function') {
                this.updatePaperSizeOptions();
            }

            // [FIX] Trigger Paper Dropdown Filter for Standard Size
            if (typeof this.filterPaperDropdownByEffectiveSize === 'function') {
                this.filterPaperDropdownByEffectiveSize();
            }
            // ▲▲▲ 追加ここまで ▲▲▲

            if (typeof this.updateAllDPIs === 'function') {
                this.updateAllDPIs();
            }

            // [FIX] Update layout options availability (e.g., photo_card borderless exclusion based on selected set)
            if (typeof this.updateLayoutOptionsAvailability === 'function') {
                this.updateLayoutOptionsAvailability();
            }

            // Trigger progressive disclosure (and other visual updates) when size is selected
            if (typeof this.updateVisualState === 'function') {
                this.updateVisualState();
            }
        }

        updateCustomCalculation() {
            const w = parseInt(this.elements.customShort.value) || 0;
            const h = parseInt(this.elements.customLong.value) || 0;

            // [NEW] Track Dimensions
            this.currentDimensions = (w > 0 && h > 0) ? [w, h] : null;

            this.updateAllDPIs(); // [NEW] Recalc DPI (Fix for Custom Size)

            // [NEW] 定形外モード: 入力寸法に応じて加工タイプを出し分ける(ブックマットは 763×1066mm 超で非表示)。
            // 寸法が 0/未入力に戻った場合も呼び、ブックマットを再表示する。
            this.updateProcessingTypeAvailability();

            if (w <= 0 || h <= 0) {
                if (this.elements.customDisplay) this.elements.customDisplay.textContent = "-- x -- mm";
                if (this.elements.priceDisplay) this.elements.priceDisplay.textContent = "--";
                this.currentBasePrice = 0;
                this.updateTotalDisplay();
                return;
            }

            const inputShort = Math.min(w, h);
            const inputLong = Math.max(w, h);

            // Dynamic Matching Logic
            let bestMatch = null;

            // [NEW] Photo Card Logic: Filter by Layout (Option 2)
            let requiredOption2 = null;
            if (this.formType === 'photo_card') {
                const layoutRadio = this.container.querySelector('input[name="properties[印刷レイアウト]"]:checked');
                if (layoutRadio) {
                    const layoutMap = {
                        'border': 'フチあり',
                        'borderless': 'フチなし',
                        'data': '完全データ入稿'
                    };
                    requiredOption2 = layoutMap[layoutRadio.dataset.layout] || layoutRadio.value;
                }
            }

            // 1. Exact Match First
            for (const size of this.availableSizes) {
                if (Math.abs(size.short - inputShort) < 2 && Math.abs(size.long - inputLong) < 2) {
                    // If Photo Card, check Option 2
                    if (requiredOption2) {
                        // Check exact match on Option 2
                        // Note: option2 might be undefined if not captured (fixed in parseProductSizes)
                        if (size.options && size.options[1] === requiredOption2) {
                            bestMatch = size;
                            break;
                        }
                    } else {
                        bestMatch = size;
                        break;
                    }
                }
            }

            // 2. Smallest Fit Second (Only if exact match failed)
            if (!bestMatch) {
                // ... existing fit logic but maybe irrelevant for standard sizes?
                // Actually standard sizes usually hit Exact Match.
                // This fallback is for loose matching. 
                // We should apply the same Option 2 filter here.

                for (const size of this.availableSizes) {
                    if (size.short >= inputShort && size.long >= inputLong) {
                        if (requiredOption2) {
                            if (size.options && size.options[1] === requiredOption2) {
                                bestMatch = size;
                                break;
                            }
                        } else {
                            bestMatch = size;
                            break;
                        }
                    }
                }
            }

            if (bestMatch) {
                if (this.elements.customDisplay) this.elements.customDisplay.textContent = `ご注文サイズ: ${bestMatch.name} `;
                this.currentBasePrice = bestMatch.price;
                if (this.elements.priceDisplay) this.elements.priceDisplay.textContent = this.formatCurrency(bestMatch.price);
                this.updateMainVariantId(bestMatch.id);

            } else {
                if (this.elements.customDisplay) this.elements.customDisplay.textContent = "対応サイズなし";
                const subject = encodeURIComponent("サイズ見積もり依頼");
                const prodName = (this.productData && this.productData.title) || window.rfConfig?.productTitle || "商品名不明";
                // [FIX] s/l は当メソッドに未定義で ReferenceError → 「対応サイズなし」時にクラッシュし mailto/価格リセットが未実行だった。
                const body = encodeURIComponent(`【ご入力いただいた内容】\n商品名: ${prodName}\n希望サイズ: ${inputShort}mm x ${inputLong}mm`);
                if (this.elements.priceDisplay) this.elements.priceDisplay.innerHTML = `<a href="mailto:info@photopri.com?subject=${subject}&body=${body}" style="text-decoration:underline; color:inherit;">お問合せください</a>`;
                this.currentBasePrice = 0;
            }
            // Bind methods
            this.updateTotalDisplay = this.updateTotalDisplay.bind(this);
            this.validateFraming = this.validateFraming.bind(this);

            // [FIX] Trigger Paper Dropdown Filter for Custom Size
            if (typeof this.filterPaperDropdownByEffectiveSize === 'function') {
                this.filterPaperDropdownByEffectiveSize();
            }
        }

        init() {
            if (!this.elements.form) return;

            // [FIX] Immediately lock all sections after the first visible one
            // This prevents FOUC (Flash of Unstyled Content) when using display:none
            const allSections = Array.from(this.container.querySelectorAll('.rf-section'));
            let foundFirstVisible = false;
            allSections.forEach(s => {
                if (s.classList.contains('rf-content-hidden')) return;
                if (!foundFirstVisible) {
                    foundFirstVisible = true;
                    return; // Keep first visible section shown
                }
                s.classList.add('rf-locked-progressive');
            });

            this.initListeners();
            this.initFramingLogic(); // New Logic

            // Initial Calculation
            this.updateTotalDisplay();
            this.updateVisualState(); // Initial Visual Sync (refines the locking)

            // [FIX] Initial Paper Filter Check
            if (typeof this.filterPaperDropdownByEffectiveSize === 'function') {
                this.filterPaperDropdownByEffectiveSize();
            }
        }
        updateMainVariantId(id) {
            if (!id) return;
            const form = this.container.closest('form');
            if (form) {
                const idInput = form.querySelector('input[name="id"]');
                if (idInput) {
                    idInput.value = id;
                    idInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        }




        formatBytes(bytes, decimals = 2) {
            if (!+bytes) return '0 Bytes';
            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]} `;
        }

        formatCurrency(cents) {
            return new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY' }).format(cents / 100);
        }

        // [NEW] DPI Calculation Helper
        calculateDPI(imgW, imgH) {
            if (!this.currentDimensions || !imgW || !imgH) return null;
            const [printW, printH] = this.currentDimensions;

            // Match orientation (Long side to Long side) logic
            const printLong = Math.max(printW, printH);
            // const printShort = Math.min(printW, printH);
            const imgLong = Math.max(imgW, imgH);

            // inches = mm / 25.4
            const inchesLong = printLong / 25.4;

            if (inchesLong <= 0) return null;

            const dpi = Math.round(imgLong / inchesLong);
            return dpi;
        }

        // [NEW] Truncate Filename
        truncateFilename(name, maxLength = 20) {
            if (name.length <= maxLength) return name;
            // e.g. "very-long-filename...jpg"
            const extIndex = name.lastIndexOf('.');
            if (extIndex === -1) return name.slice(0, 10) + '...' + name.slice(-7);

            const ext = name.slice(extIndex); // .jpg
            const base = name.slice(0, extIndex);

            // simple strategy: keep start + end of base? 
            const remaining = maxLength - ext.length - 3; // 3 for '...'
            if (remaining < 2) return name.slice(0, 10) + '...' + name.slice(-7); // Fallback

            const part = Math.floor(remaining / 2);
            return base.slice(0, part) + '...' + base.slice(-part) + ext;
        }

        // [NEW] Update All DPIs on Size Change
        updateAllDPIs() {
            // [FIX ST-47 2026-07-31] 入稿UIを持たないフォーム (simple_buy = 用紙サンプル帳 / 全用紙サンプル) では
            // this.elements.fileList が存在しない。素の参照は TypeError で送信ごと落ちる (石黒報告: ボタン無反応)。
            if (!this.elements.fileList) return;
            const items = this.elements.fileList.querySelectorAll('.rf-file-item');
            items.forEach(item => {
                const w = parseInt(item.dataset.w);
                const h = parseInt(item.dataset.h);
                const badge = item.querySelector('.rf-file-res-badge');

                if (w && h && badge) {
                    const dpi = this.calculateDPI(w, h);
                    let text = `解像度: ${w} x ${h} px`;
                    if (dpi) {
                        text += ` / <span>${dpi} dpi</span>`;
                        badge.style.color = '#666';
                    } else {
                        // If standard size deselected, DPI becomes null. Just show resolution.
                        badge.style.color = '#666';
                    }
                    badge.innerHTML = text;
                    badge.style.display = 'block';
                }
            });
        }

        // [NEW 2026-07-28] アップロードを受理しない条件の唯一の正本。null = 受理。
        // 数量の自動調整(handleFiles 前半)と実際の取り込みループ(同後半)が別条件で判定すると、
        // 「注文総数だけ増えてファイルは入らない」ズレが出るため、両方ここを参照する。
        _rejectReason(file) {
            const BLOCKED_EXTENSIONS = ['exe', 'bat', 'cmd', 'sh', 'php', 'pl', 'cgi', 'dll', 'docx', 'doc', 'xlsx', 'xls', 'pptx', 'ppt', 'heic', 'raw', 'psb', 'eps'];
            const ext = String(file.name || '').split('.').pop().toLowerCase();
            if (BLOCKED_EXTENSIONS.includes(ext)) return 'ext';
            if (file.size > 1073741824) return 'size';
            return null;
        }

        // [NEW 2026-07-28] 印刷枚数の唯一の定義: ファイル毎の枚数(.rf-img-qty)の合計。
        // ファイル追加時(handleFiles)と枚数変更時(validateTotalQuantity)で定義がズレると
        // 「ファイル数=注文総数」に退行するため、両者はこの1関数を参照すること。
        getFilesTotalSheets() {
            const qtyInputs = this.elements.fileList ? this.elements.fileList.querySelectorAll('.rf-img-qty') : [];
            if (!qtyInputs.length) return this.uploadedFiles.length; // 枚数UI未描画時のみ件数にフォールバック
            let sum = 0;
            qtyInputs.forEach(input => sum += (parseInt(input.value) || 1));
            return sum;
        }

        // [NEW 2026-07-28] カート投入後、フォームとカート行を切り離す。
        // カート行は投入時点のスナップショットで、その後のフォーム編集は一切反映されない
        // (実測: フォーム3枚 / カート2枚 の不一致)。投入済み内容の変更はカート側で行う方針。
        // 入稿データと数量だけを新規注文用に戻し、仕様(サイズ/用紙/レイアウト)は次の注文で
        // 使い回せるよう残す。
        // [2026-08-01 Owner] 投入後の案内表示は PDP のオプション欄には不要として撤去。
        // 投入のフィードバックはカートドロワーの自動オープンとボタン文言が担う。
        resetAfterAddToCart() {
            try {
                this.uploadedFiles.forEach(f => {
                    try {
                        if (f.task && f.task.snapshot && f.task.snapshot.state === 'running') f.task.cancel();
                    } catch (e) { /* noop */ }
                });
                this.uploadedFiles = [];
                if (this.elements.fileList) this.elements.fileList.innerHTML = '';
                this.updateHiddenFilesInput();

                if (this.elements.qtyInput) {
                    this.elements.qtyInput.value = 1;
                    this.updateQuantity(0);
                }

                const remarksGroup = this.container.querySelector('#rf-file-remarks-group');
                if (remarksGroup) {
                    remarksGroup.style.display = 'none';
                    remarksGroup.querySelectorAll('textarea, input[type="text"]').forEach(el => { el.value = ''; });
                }

                this._gaUploadStarted = false; // 次の注文の初回アップロードを再計測する
                this.checkUploadStatusAndToggleSubmit();
            } catch (e) {
                console.warn('RF: resetAfterAddToCart failed', e);
            }
        }

        // [NEW 2026-07-28] 合計枚数が「減った」ときに注文総数を追随させる。
        // validateTotalQuantity は増加方向(合計 > 注文総数)しか見ていないため、
        // ファイル削除や枚数の引き下げでは注文総数が据え置きになり、
        // 「画像1枚(枚数1)なのに注文総数3」というズレが残っていた(＝その差分は過大請求)。
        // 増加方向は確認モーダルを出す validateTotalQuantity の担当。ここは減少方向だけを扱う。
        // 全ファイル削除時(合計0)は注文総数に触らない — アップロード無しで数量だけ指定する導線を壊さないため。
        syncOrderQtyToSheets() {
            if (this.formType === 'student_discount') return; // 学割は数量UIそのものが非表示
            if (!this.elements.qtyInput) return;
            const sum = this.getFilesTotalSheets();
            if (sum <= 0) return;
            const mainQty = parseInt(this.elements.qtyInput.value) || 1;
            if (sum < mainQty) {
                this.elements.qtyInput.value = sum;
                this.updateQuantity(0); // 価格表示・フォーム側 input[name=quantity] を同期
            }
        }

        // [NEW] Per-File Quantity Validation
        async validateTotalQuantity(changedInput, blocking = false) {
            if (this.formType === 'student_discount') return true; // [FIX] Skip quantity check for student discount

            const sum = this.getFilesTotalSheets();

            const mainQty = parseInt(this.elements.qtyInput.value) || 1;

            if (sum > mainQty) {
                const confirmed = await RFModal.confirm(
                    '数量の自動調整',
                    `画像の合計枚数(${sum}枚)が注文総数(${mainQty}枚)を超えています。<br>注文総数を ${sum} 枚に変更しますか？<br><small>※「キャンセル」を押すと、枚数を元に戻します。</small>`
                );

                if (confirmed) {
                    this.elements.qtyInput.value = sum;
                    this.updateQuantity(0); // Trigger updates
                    return true; // Resolved
                } else {
                    // Revert change
                    if (changedInput) {
                        const currentVal = parseInt(changedInput.value) || 1;
                        const overflow = sum - mainQty;
                        changedInput.value = Math.max(1, currentVal - overflow);
                    }
                    return false; // ValidState not achieved if blocking
                }
            }
            return true; // No issue
        }

        handleLayoutChange(e) {
            const selected = e.target;

            // Map values to Section IDs
            const map = {
                'border': 'rf-section-margin',
                'borderless': 'rf-section-borderless',
                'data': 'rf-section-data'
            };

            // 1. Hide ALL layout detail sections first (Default State)
            // [FIX] 非表示セクション内の input を disabled にしてデフォルト値送信を防止
            Object.values(map).forEach(id => {
                const el = this.container.querySelector('#' + id);
                if (el) {
                    this.toggleContent(el, false);
                    el.querySelectorAll('input, select, textarea').forEach(inp => inp.disabled = true);
                    const confirmCheck = el.querySelector('input[name="properties[レイアウト確認]"]');
                    if (confirmCheck) confirmCheck.checked = false;
                }
            });

            // 2. Reset specific inputs for ALL layout types
            const checkBorderless = this.container.querySelector('#rf-check-borderless');
            if (checkBorderless) checkBorderless.checked = false;

            // [FIX #P30328] Reset complete data entry checkboxes when switching layouts
            const checkDataNoResize = this.container.querySelector('#rf-check-data-no-resize');
            if (checkDataNoResize) checkDataNoResize.checked = false;

            const checkDataMargin = this.container.querySelector('#rf-check-data-margin');
            if (checkDataMargin) checkDataMargin.checked = false;

            const descContainer = this.container.querySelector('#rf-layout-desc-container');

            // If deselected (checked is false), Hide Everything and Return
            if (!selected.checked) {
                if (descContainer) {
                    // Hard reset to ensure text disappears immediately
                    descContainer.style.display = 'none';
                    descContainer.classList.remove('rf-open', 'rf-expandable');
                    const inner = descContainer.querySelector('.rf-expandable-inner');
                    if (inner) inner.innerHTML = '';
                }
                return;
            }

            const layoutType = selected.dataset.layout || selected.value;

            // 3. Show the relevant section
            // [FIX] 表示するセクション内の input の disabled を解除（setupVisibility で disabled にされた場合に対応）
            const targetId = map[layoutType];
            if (targetId) {
                const targetEl = this.container.querySelector('#' + targetId);
                if (targetEl) {
                    this.toggleContent(targetEl, true);
                    targetEl.querySelectorAll('input, select, textarea').forEach(inp => inp.disabled = false);
                }
            }

            // 4. Update Layout Description (Single Container)
            const descKey = layoutType;

            if (descKey && descContainer) {
                const template = this.container.querySelector('#rf-desc-' + descKey);
                if (template) {
                    const inner = descContainer.querySelector('.rf-expandable-inner');
                    if (inner) {
                        const content = template.innerHTML.trim();
                        if (!content) {
                            // [FIX] Hide if content is empty (e.g. wood_panel)
                            descContainer.style.display = 'none';
                            descContainer.classList.remove('rf-open', 'rf-expandable');
                            inner.innerHTML = '';
                        } else {
                            inner.innerHTML = template.innerHTML;
                            descContainer.style.display = '';
                            descContainer.classList.add('rf-expandable');
                            this.toggleContent(descContainer, true);
                        }
                    }
                }
            } else if (descContainer) {
                // Hard reset
                descContainer.style.display = 'none';
                descContainer.classList.remove('rf-open', 'rf-expandable');
                const inner = descContainer.querySelector('.rf-expandable-inner');
                if (inner) inner.innerHTML = '';
            }


            // [NEW] Trigger Variant Re-calculation if Layout affects Variant (e.g. Photo Card)
            if (this.formType === 'photo_card') {
                // Re-run size selection logic to pick correct variant based on new layout
                this.handleSizeSelectChange({ target: this.elements.sizeSelect });

                // [NEW] Dynamically toggle Pre-submission Check section based on layout and margin type
                this._updatePhotoCardPrecheckVisibility();
            }
        }

        _updatePhotoCardPrecheckVisibility() {
            if (this.formType !== 'photo_card') return;
            const precheckSection = this.container.querySelector('#rf-section-precheck');
            if (!precheckSection) return;

            const layoutRadio = this.container.querySelector('input[name="properties[印刷レイアウト]"]:checked');
            const layoutType = layoutRadio ? (layoutRadio.dataset.layout || layoutRadio.value) : null;
            
            const marginRadio = this.container.querySelector('input[name="properties[フチ処理]"]:checked');
            const marginType = marginRadio ? marginRadio.value : 'おまかせ';

            if (layoutType === 'borderless' || (layoutType === 'border' && marginType === 'おまかせ')) {
                precheckSection.style.display = 'none';
                // Uncheck the checkbox if we are hiding the section so it doesn't submit/validate
                const checkPreMargin = precheckSection.querySelector('#rf-check-pre-margin');
                if (checkPreMargin) checkPreMargin.checked = false;
            } else {
                precheckSection.style.display = 'block';
            }
        }

        handleMarginTypeChange(e) {
            const val = e.target.value;
            this.toggleContent(this.elements.marginWidthInputs, val === 'フチ幅指定');
            this.toggleContent(this.elements.marginSizeInputs, val === '画像サイズ指定');

            if (this.formType === 'photo_card') {
                this._updatePhotoCardPrecheckVisibility();
            }
        }

        toggleContent(element, show) {
            if (!element) return;

            if (show) {
                element.classList.remove('rf-content-hidden');
                // [FIX] Clear inline styles to let CSS progressive disclosure control visibility
                // Do NOT set display:block — that overrides CSS sibling combinator hiding
                element.style.removeProperty('display');
                element.style.removeProperty('height');
                element.style.removeProperty('opacity');

                // Add 'rf-open' for expandable items
                if (element.classList && typeof element.classList.contains === 'function' && element.classList.contains('rf-expandable')) {
                    if (typeof requestAnimationFrame === 'function') {
                        requestAnimationFrame(() => element.classList.add('rf-open'));
                    } else {
                        element.classList.add('rf-open');
                    }
                }
            } else {
                if (element.classList && typeof element.classList.contains === 'function' && element.classList.contains('rf-expandable')) {
                    element.classList.remove('rf-open');
                } else {
                    if (element.style) {
                        element.style.display = 'none';
                        element.style.removeProperty('height');
                        element.style.removeProperty('opacity');
                    }
                    if (element.classList) element.classList.add('rf-content-hidden');
                }
            }
        }

        disableNumberScroll() {
            // [FIX] Robustly prevent scroll from changing number values
            // Listen on document to catch all inputs (even dynamic ones)
            // Use { passive: false } to allow preventDefault()
            document.addEventListener('wheel', (e) => {
                if (e.target.tagName === 'INPUT' && e.target.type === 'number') {
                    // Always prevent default value change
                    e.preventDefault();

                    // If focused, blur it to remove the "active" state that might confuse users
                    // trying to scroll the page.
                    if (document.activeElement === e.target) {
                        e.target.blur();
                    }
                }
            }, { passive: false });
        }

        // [2026-06-23 Phase1] ストレージキー用にファイル名を ASCII 安全化(表示名 fileObj.name は元のまま保持)。
        // 日本語名は _ に潰れるがキーのみ。/ 等によるパス・トラバーサル混入も封じる。
        _rfSafeFilename(name) {
            const dot = (name || '').lastIndexOf('.');
            let base = dot > 0 ? name.slice(0, dot) : (name || '');
            let ext  = dot > 0 ? name.slice(dot + 1) : '';
            base = base.replace(/[^A-Za-z0-9._-]/g, '_').slice(0, 80);
            ext  = ext.replace(/[^A-Za-z0-9]/g, '').slice(0, 12);
            if (!base) base = 'file';
            return ext ? `${base}.${ext}` : base;
        }

        async handleFiles(rawFiles) {
            // Create static array immediately because clearing input.value wipes the live FileList
            const files = Array.from(rawFiles);

            // Clear input to allow re-selecting same files
            if (this.elements.fileInput) this.elements.fileInput.value = '';

            console.log("handleFiles processing:", files);
            this.elements.uploadError.style.display = 'none';

            // Show Remarks Field
            const remarksGroup = this.container.querySelector('#rf-file-remarks-group');
            if (remarksGroup) remarksGroup.style.display = 'block';

            const currentQty = parseInt(this.elements.qtyInput.value) || 1;

            // [FIX 2026-07-28] 数量の自動調整は「後段の取り込みループが実際に受理するファイル」だけを数える。
            // 旧実装は files.length(=ドロップした全件)で数えていたため、拡張子ブロック(.heic 等・iPhone 実写で頻出)
            // や 1GB 超で弾かれるファイルまで注文総数に加算され、注文総数 > 実際の入稿枚数(=過大請求)になっていた。
            // 判定は取り込みループと同じ _rejectReason() を唯一の正本にする(条件が2箇所に散ると再発する)。
            const acceptedCount = files.filter(f => !this._rejectReason(f)).length;

            if (this.formType === 'student_discount') {
                if (this.uploadedFiles.length + acceptedCount > 2) {
                    this.showError(this.elements.dropzone, `学割フォームでは最大2枚までしか画像をアップロードできません。`);
                    return;
                }
            } else if (acceptedCount > 0) {
                // [FIX 2026-07-28] 印刷枚数は「ファイル数」ではなく「ファイル毎の枚数(.rf-img-qty)の合計」。
                // 旧実装は uploadedFiles.length で比較していたため、既存ファイルに枚数2以上が
                // 1つでもあると ファイル数 < 合計枚数 となり、追加ファイル分が `>` を通過せず
                // 注文総数が引き上げられなかった(例: A=1枚 + B=2枚 → 注文3。ここにCを追加しても
                // ファイル数3 > 3 が false のため注文3のまま＝合計4枚と不整合)。
                const totalSheets = this.getFilesTotalSheets() + acceptedCount; // 新規ファイルは枚数=1で追加される
                if (totalSheets > currentQty) {
                    const confirmed = await RFModal.confirm(
                        '数量の自動調整',
                        `画像の合計枚数(${totalSheets}枚)が注文総数(${currentQty}枚)を超えています。\n注文総数を ${totalSheets} 枚に変更しますか？`
                    );

                    if (confirmed) {
                        this.elements.qtyInput.value = totalSheets;
                        this.updateQuantity(0); // Trigger update
                    } else {
                        this.showError(this.elements.dropzone, `注文数(${currentQty}枚)を超えるファイルはアップロードできません。`);
                        return;
                    }
                }
            }

            // [2026-06-23 Phase1] 匿名認証の uid を確定(未サインインなら authReady を待つ)。
            // 取得失敗時は 'anon'(Phase0 ルールでは write 可のため無停止)。Phase1 ルール厳格化(2.8.01公開後)で anon は拒否され、
            // その時点でフォールバックを明示エラー化する(段取りは directive 参照)。
            let rfUid = window.RF_FIREBASE && window.RF_FIREBASE.uid;
            if (!rfUid && window.RF_FIREBASE && window.RF_FIREBASE.authReady) {
                try { rfUid = await window.RF_FIREBASE.authReady; }
                catch (e) { rfUid = null; }
            }
            // [FIX 2026-07-28 Phase1] 旧実装は uid 取得に失敗すると黙って 'anon' 配下に書いていた。
            // Storage ルールを uid 一致必須に締めた後は、その書込は拒否され「アップロード中のまま
            // 終わらない」状態になる(顧客からは原因不明のフリーズに見える)。ここで明示的に止める。
            if (!rfUid) {
                console.error('RF: anonymous auth unavailable — upload aborted');
                this._track('rf_upload_auth_fail', {});
                RFModal.alert(
                    'アップロードを開始できませんでした',
                    'アップロードの準備に失敗しました。<br>お手数ですが、ページを再読み込みしてもう一度お試しください。<br><br>'
                    + '解決しない場合は<a href="/pages/contact" style="text-decoration:underline;color:inherit;">お問い合わせ</a>よりご連絡ください。'
                );
                return;
            }
            const uidSeg = rfUid;

            for (let file of files) {
                // Extension Check (Blacklist) / Size Check (1GB)
                // 判定は _rejectReason() に一本化。ここは拒否理由に応じた通知だけを担う
                // (通知は数量確認モーダルの後。RFModal は overlay を1枚使い回すため、
                //  先に alert を出すと後続の confirm に上書きされて理由が読めなくなる)。
                const ext = String(file.name || '').split('.').pop().toLowerCase(); // 後段のサムネイル生成でも使用
                const reject = this._rejectReason(file);
                if (reject === 'ext') {
                    RFModal.alert(
                        '未対応のファイル形式です',
                        `申し訳ありませんが、アップロードされた「${file.name}」はセキュリティまたはシステム上の理由により未対応です。<br><br>` +
                        `詳細は <a href="/pages/data#toc02" target="_blank" style="text-decoration:underline; color:#000;">入稿データについて</a> をご確認ください。`
                    );
                    continue;
                }
                if (reject === 'size') {
                    // GA4: 1GB 上限に当たった回数と、弾かれた実サイズ。
                    // Storage には >1GB のオブジェクトが原理的に存在しない(右側打ち切り)ため、
                    // 「上限が実態に合っているか」を測れる分母はここしかない。
                    // param 名は property 全体で一意になる語にする (reason / mb は他イベントと衝突する)
                    this._track('rf_upload_reject', { reject_reason: 'size', reject_mb: Math.round(file.size / 1048576) });
                    this.showError(this.elements.dropzone, `${file.name} は1GBを超えているためアップロードできません。`);
                    continue;
                }

                // create Storage Ref
                const fb = window.RF_FIREBASE;
                if (!fb) continue;
                if (!this.storage) this.storage = fb.storage;
                const safeName = this._rfSafeFilename(file.name);
                const storagePath = `uploads/${uidSeg}/${Date.now()}_${safeName}`;
                const storageRef = fb.ref(this.storage, storagePath);
                const uploadTask = fb.uploadBytesResumable(storageRef, file);
                const uploadStartedAt = Date.now();   // 失敗時の経過秒を出すため。ファイル毎に持つ
                if (!this._gaUploadStarted) { this._gaUploadStarted = true; this._track('rf_upload_start', {}); }   // GA4: 初回アップロード開始(モバイル最大の失敗点)

                // Add to list
                const fileId = Date.now() + Math.random().toString(36).substr(2, 9);
                const fileObj = {
                    id: fileId,
                    file: file,
                    task: uploadTask,
                    ref: storageRef,
                    name: file.name, // Keep full name for data
                    downloadUrl: null
                };
                this.uploadedFiles.push(fileObj);

                // UI Item
                const item = document.createElement('div');
                item.className = 'rf-file-item';
                // Store Dimensions
                item.dataset.w = "";
                item.dataset.h = "";


                // Thumbnail Logic (Icons + Generator)
                const thumbGen = new ThumbnailGenerator();
                let thumbHTML = '';

                // 1. Standard Images (Immediate)
                if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(ext)) {
                    const objectUrl = URL.createObjectURL(file);
                    thumbHTML = `<img src="${objectUrl}" class="rf-file-thumb" alt="preview">`;
                } else {
                    // 2. Special Formats (Initial Loading -> Async Generate -> Fallback Icon)

                    // SVG Icons Definitions (for Fallback)
                    let iconPath = '';
                    const iconStyle = 'width: 40px; height: 40px; stroke-width: 1.5;';
                    if (['ai', 'pdf'].includes(ext)) {
                        iconPath = `<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline>`;
                    } else if (['psd', 'tiff', 'tif'].includes(ext)) {
                        iconPath = `<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline>`;
                    } else {
                        iconPath = `<path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline>`;
                    }

                    const fallbackIconHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-linecap="round" stroke-linejoin="round" style="${iconStyle}">${iconPath}</svg>`;
                    const thumbId = `thumb-${fileId}`;

                    // Initial HTML: Loading Spinner
                    // Using simple CSS spinner
                    const spinnerHTML = `
                    <div class="rf-thumb-spinner" style="width:20px; height:20px; border:2px solid #ccc; border-top-color:#333; border-radius:50%; animation: rf-spin 1s linear infinite;"></div>
                    <style>@keyframes rf-spin {to{transform: rotate(360deg);}}</style>
                `;

                    thumbHTML = `<div id="${thumbId}" style="display:flex; align-items:center; justify-content:center; width:60px; height:60px; background:#f9f9f9; border-radius:4px;">
                                ${spinnerHTML}
                             </div>`;

                    // Async Generation
                    // Use setTimeout to allow UI to render the spinner before heavy JS starts
                    setTimeout(() => {
                        thumbGen.generate(file).then(url => {
                            const container = document.getElementById(thumbId);
                            if (!container) return;

                            if (url) {
                                // Success: Show Image
                                container.innerHTML = `<img src="${url}" class="rf-file-thumb" alt="preview" style="width:100%; height:100%; object-fit:contain;">`;
                                container.style.background = 'transparent';
                            } else {
                                // Failure: Show Fallback Icon
                                container.innerHTML = fallbackIconHTML;
                            }
                        }).catch(e => {
                            const container = document.getElementById(thumbId);
                            if (container) container.innerHTML = fallbackIconHTML;
                        });
                    }, 50);
                }

                // Truncate Filename for Display
                const displayName = this.truncateFilename(file.name);

                // Default Resolution Text
                let resText = '';

                // Async Metadata Reading
                ImageMetadataReader.read(file).then(meta => {
                    if (meta) {
                        item.dataset.w = meta.width;
                        item.dataset.h = meta.height;

                        const dpi = this.calculateDPI(meta.width, meta.height);
                        let text = `解像度: ${meta.width} x ${meta.height} px`;
                        if (dpi) {
                            text += ` / <span>${dpi} dpi</span>`;
                        }
                        const badge = item.querySelector('.rf-file-res-badge');
                        if (badge) {
                            badge.innerHTML = text;
                            badge.style.display = 'block';
                            badge.style.color = '#666'; // Always neutral
                        }
                    }
                });

                // Improved File Item
                // [FIX 2026-07-28] 枚数入力の onchange="window.rfForm.validateTotalQuantity(this, true)" を削除。
                // window.rfForm はテーマ内のどこにも代入されておらず(grep 実測: 参照1件・代入0件)、枚数を
                // 変更するたびに TypeError を投げていた。実際に効いていたのは下で addEventListener('change')
                // する方だけ。両方生かすと確認モーダルが二重に出るため、生きている方に一本化する。
                item.innerHTML = `
                <div class="rf-file-info">
                    ${thumbHTML}
                    <div class="rf-file-details">
                        <span class="rf-file-name" title="${file.name}">${displayName}</span>
                        <span class="rf-file-size">${this.formatBytes(file.size)}</span>
                        <div class="rf-file-res-badge" style="display:none; font-size: 11px; color: #666; margin-top: 4px;"></div>
                    </div>
                </div>

                <!-- Per-Image Quantity -->
                <div class="rf-file-qty-wrapper" style="margin-left: auto; margin-right: 15px; display: flex; flex-direction: column; align-items: flex-end;">
                    <div style="font-size: 10px; color: #888; margin-bottom: 2px;">枚数</div>
                    <input type="number" 
                           class="rf-img-qty" 
                           value="1" 
                           min="1" 
                           style="width: 50px; padding: 4px; border: 1px solid #ddd; border-radius: 4px; text-align: center;"
                    />
                </div>

                <div class="rf-file-meta">
                    <!-- Circular Progress SVG -->

                    <button type="button" class="rf-file-remove" aria-label="削除">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                    </button>
                </div>
            `;

                this.elements.fileList.appendChild(item);
                this.checkUploadStatusAndToggleSubmit();



                // Remove Event Listener
                const removeBtn = item.querySelector('.rf-file-remove');
                removeBtn.addEventListener('click', () => {
                    this.removeFile(file.name, item);
                    // Also cancel upload task?
                    if (uploadTask && uploadTask.snapshot.state === 'running') {
                        uploadTask.cancel();
                    }
                });

                // Quantity Change Listener
                const qtyInput = item.querySelector('.rf-img-qty');
                qtyInput.addEventListener('change', async (e) => {
                    if (e.target.value < 1) e.target.value = 1;
                    await this.validateTotalQuantity(e.target);   // 増加方向(確認モーダル)
                    this.syncOrderQtyToSheets();                  // 減少方向(枚数を下げた場合)
                });
                qtyInput.addEventListener('click', (e) => e.stopPropagation());

                // Bind Upload Task Events
                uploadTask.on('state_changed',
                    (snapshot) => {
                        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

                        item.style.setProperty('--progress', progress + '%');
                    },
                    (error) => {
                        console.error("Upload failed:", error);
                        item.classList.add('rf-error');
                        // GA4: アップロード失敗。
                        // 🔴 code だけだと 8/25〜 の実測が storage/unknown ばかりで**何も分からない**
                        //    (unknown は SDK が HTTP レスポンスを分類できなかった時の総称であって、
                        //     原因が無いという意味ではない)。文言を決める前に実体を割るための診断を添える。
                        //    - err_detail  : サーバの生応答。真の理由(403/401/CORS/quota 等)はここにしか出ない
                        //    - err_progress: 失敗時点の進捗%。0 近辺=開始できていない / 90超=転送末尾で落ちた、を分ける
                        //    - err_elapsed_s / err_mb: タイムアウト仮説の検証用(遅い回線×大容量なら両方が伸びる)
                        let detail = '';
                        try {
                            const sr = (error && (error.serverResponse
                                || (error.customData && error.customData.serverResponse))) || '';
                            const st = (error && (error.status_ || error.status)) || '';
                            // GA4 のパラメータ値は 100 文字上限。超えると**その値が丸ごと落ちる**ので必ず切る
                            detail = (st ? 'http' + st + ' ' : '') + String(sr).replace(/\s+/g, ' ').slice(0, 90);
                        } catch (e) { detail = 'detail_failed'; }
                        let pct = -1, mb = -1;
                        try {
                            const snap = uploadTask && uploadTask.snapshot;
                            if (snap && snap.totalBytes > 0) {
                                pct = Math.round((snap.bytesTransferred / snap.totalBytes) * 100);
                                mb = Math.round(snap.totalBytes / 1048576);
                            }
                        } catch (e) { /* 進捗が取れなくても失敗自体は記録する */ }
                        this._track('rf_upload_error', {
                            code: (error && error.code) || 'unknown',
                            err_detail: detail || 'empty',
                            err_progress: pct,
                            err_elapsed_s: Math.round((Date.now() - uploadStartedAt) / 1000),
                            err_mb: mb,
                        });
                        this.checkUploadStatusAndToggleSubmit();
                        // Clean up array?
                    },
                    async () => {
                        const downloadURL = await window.RF_FIREBASE.getDownloadURL(uploadTask.snapshot.ref);
                        if (document.body.contains(item)) {
                            // Update object in array with URL
                            fileObj.downloadUrl = downloadURL;
                            this.updateHiddenFilesInput();
                            item.classList.add('rf-upload-complete');
                            this._track('rf_upload_complete', {});   // GA4: アップロード成功
                            this.checkUploadStatusAndToggleSubmit();
                        }
                    }
                );
            }
        }



        removeFile(fileName, itemElement) {
            // Remove from Array
            this.uploadedFiles = this.uploadedFiles.filter(f => f.name !== fileName);

            // Remove from DOM
            if (itemElement && itemElement.parentNode) {
                itemElement.parentNode.removeChild(itemElement);
            }

            // Update Hidden Inputs
            this.updateHiddenFilesInput();
            this.checkUploadStatusAndToggleSubmit();
            this.syncOrderQtyToSheets(); // [FIX 2026-07-28] 削除で減った合計枚数に注文総数を追随させる

            // Hide Remarks Field if empty
            if (this.uploadedFiles.length === 0) {
                const remarksGroup = this.container.querySelector('#rf-file-remarks-group');
                if (remarksGroup) remarksGroup.style.display = 'none';
            }
        }

        // [FIX ST-47b 2026-07-31] ボタン文言の復元は「控えた原文言 → 既存 originalText → 従来定数」の順。
        restoreAddToCartLabel(btn) {
            const el = btn || this.elements.addToCartBtn;
            if (!el) return;
            el.textContent = el.dataset.rfOriginalText || el.dataset.originalText || 'カートに入れる';
        }

        updateHiddenFilesInput() {
            // Collect names with quantities
            // [FIX ST-47 2026-07-31] 入稿UIを持たないフォーム (simple_buy = 用紙サンプル帳 / 全用紙サンプル) では
            // this.elements.fileList が存在しない。素の参照は TypeError で送信ごと落ちる (石黒報告: ボタン無反応)。
            // ここが ST-47 の実クラッシュ地点: handleRobustSubmit (override) から無条件に呼ばれる。
            const items = this.elements.fileList ? this.elements.fileList.querySelectorAll('.rf-file-item') : [];
            const fileData = [];

            items.forEach((item, index) => {
                // Find corresponding file in uploadedFiles to get clean name/url?
                // Actually uploadedFiles relies on push order which matches DOM append order usually, 
                // but verify if user removes items.
                // Better: attached data to item? or finding by name.
                const nameEl = item.querySelector('.rf-file-name');
                const qtyEl = item.querySelector('.rf-img-qty');

                if (nameEl && qtyEl) {
                    const name = nameEl.textContent.trim();
                    const qty = parseInt(qtyEl.value) || 1;
                    fileData.push(`${name} (${qty}枚)`);
                }
            });

            const names = fileData.join(', ');
            // [FIX] Filter out null/empty URLs to prevent missing links
            const urls = this.uploadedFiles
                .map(f => f.downloadUrl)
                .filter(url => url && url.trim() !== '')
                .join(', ');

            const namesInput = this.container.querySelector('#rf-file-names');
            const urlsInput = this.container.querySelector('#rf-file-urls');

            if (namesInput) namesInput.value = names;
            if (urlsInput) urlsInput.value = urls;

            console.log("RF: Updated Hidden Inputs", { names, urls, totalFiles: this.uploadedFiles.length, completedUrls: urls.split(',').filter(u => u.trim()).length });
        }

        checkUploadStatusAndToggleSubmit() {
            // [FIX ST-47 2026-07-31] 入稿UIを持たないフォーム (simple_buy = 用紙サンプル帳 / 全用紙サンプル) では
            // this.elements.fileList が存在しない。素の参照は TypeError で送信ごと落ちる (石黒報告: ボタン無反応)。
            // 入稿UIが無い面ではボタン文言 ('カートに入れる') を書き換えてしまうため、触らず抜ける。
            if (!this.elements.fileList) return;
            // [FIX] Check for In-Progress OR Failed Uploads
            const uploadingItems = this.elements.fileList.querySelectorAll('.rf-file-item:not(.rf-upload-complete):not(.rf-error)');
            const errorItems = this.elements.fileList.querySelectorAll('.rf-file-item.rf-error');

            const btn = this.elements.addToCartBtn || this.container.querySelector('.rf-btn-add-to-cart');

            if (btn) {
                // [FIX] Disable if uploading OR error exists
                if (uploadingItems.length > 0) {
                    btn.disabled = true;
                    if (!btn.dataset.originalText) btn.dataset.originalText = btn.textContent;
                    btn.textContent = 'アップロード中...';
                } else if (errorItems.length > 0) {
                    // [NEW] Disable on Error and prompt removal
                    btn.disabled = true;
                    if (!btn.dataset.originalText) btn.dataset.originalText = btn.textContent;
                    btn.textContent = 'エラーファイルを削除してください';
                } else {
                    btn.disabled = false;
                    this.restoreAddToCartLabel(btn);
                }
            }
        }

        showError(element, msg) {
            element.classList.add('rf-input-error');
            setTimeout(() => element.classList.remove('rf-input-error'), 400);

            if (msg && this.elements.uploadError) {
                this.elements.uploadError.textContent = msg;
                this.elements.uploadError.style.display = 'block';
            }
        }

        // [2026-07-17] 入力エラーは「収集して、最上位の1件だけ」出す。
        // このフォームは段階解錠式なので、まだ到達していない下の項目(用紙/カラー/レイアウト)にまで
        // エラーを撒くのは無意味かつ煩雑。元設計どおり「最初の未入力へ飛ばす」に揃える。
        // ・showFieldError/showSectionError は即描画せず候補として貯めるだけ。
        // ・renderFirstError() が画面内で一番上の1件だけを描画してそこへスクロールする。
        // 旧実装で 400ms/1500ms の一過性演出が smooth スクロール(740〜1020ms)途中で消えていた問題は、
        // 「直るまで残る文言」で解消する。
        // [2026-07-17] 必須チェックボックスのエラー文言を、所属セクションの見出しから具体化する。
        // 例: 見出し「フチなし設定 *」→「フチなし設定の項目にチェックしてください」。
        // 見出しが取れない場合は無難な既定文へ。
        _requiredCheckboxMessage(cb) {
            const sec = cb.closest ? cb.closest('.rf-section') : null;
            const titleEl = sec ? sec.querySelector('.rf-section-title') : null;
            let title = titleEl ? (titleEl.textContent || '') : '';
            title = title.replace(/[*＊]/g, '').replace(/\s+/g, ' ').trim();   // 必須マーク・余白を除去
            if (title) return `${title}の項目にチェックしてください`;
            return '確認事項にチェックしてください';
        }

        // 未到達(検証開始時に段階解錠で施錠されていた)セクションかどうか。
        // 未到達 = 上流に未入力があり、そちらが最上位エラーとして出る → ここは表示しない。
        _wasLockedAtStart(el) {
            const set = this._lockedAtStart;
            if (!set || !el) return false;
            const sec = el.classList && el.classList.contains('rf-section') ? el : (el.closest ? el.closest('.rf-section') : null);
            return !!(sec && set.has(sec));
        }
        showFieldError(element, msg) {
            if (!element) return;
            this._pendingErrors = this._pendingErrors || [];
            this._pendingErrors.push({ kind: 'field', el: element, msg, locked: this._wasLockedAtStart(element) });
        }
        showSectionError(section, msg, inputsSelector) {
            if (!section) return;
            this._pendingErrors = this._pendingErrors || [];
            this._pendingErrors.push({ kind: 'section', el: section, msg, inputsSelector, locked: this._wasLockedAtStart(section) });
        }

        // 前回の検証で出したエラー表示をすべて片付ける(古い警告を残さない)。
        clearFieldErrors() {
            this.container.querySelectorAll('.rf-field-error').forEach(b => b.style.display = 'none');
            this.container.querySelectorAll('.rf-input-error').forEach(e => e.classList.remove('rf-input-error'));
        }

        // 貯めた候補のうち、画面内で最も上にある1件だけを描画し、そこへスクロールする。
        // 戻り値 = 描画対象の要素(スクロール用) or null。
        // ===== GA4 計測 (house pattern: paper-diagnostic/simulator 等と同一。gtag/dataLayer 双方へ push、無ければ黙って no-op) =====
        _track(name, params) {
            try {
                const payload = Object.assign({ tool: 'rf_form', form_type: this.formType || 'unknown' }, params || {});
                if (typeof window.gtag === 'function') window.gtag('event', name, payload);
                if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, payload));
            } catch (e) { /* swallow */ }
        }
        // 初回操作で1回だけ rf_form_start (母数)
        _gaFormStart() {
            if (this._gaStartBound) return;
            this._gaStartBound = true;
            // 🔴 「人が触ったか」を change/input と切り離して持つ (2026-08-18)。
            //    理由1: updateMainVariantId() 等が new Event('change',{bubbles:true}) を
            //           撃つため、`?variant=` 付きで着地しただけで rf_form_start が
            //           立っていた。商品フィード広告(OpenAI/P-max/Meta カタログ)は必ず
            //           variant 付きで来るので、有料流入だけが構造的に水増しされる。
            //    理由2: 逆に isTrusted だけで弾くと計測が死ぬ。標準/カスタム切替は
            //           実クリックを受けてから合成 change を撃つので untrusted になる。
            //    → 実入力で _gaUserActed を立て、その後の change/input で初めて計上する。
            const markActed = (e) => { if (!e || e.isTrusted !== false) this._gaUserActed = true; };
            ['pointerdown', 'keydown', 'click'].forEach((t) =>
                this.container.addEventListener(t, markActed, true));
            const fire = (e) => {
                markActed(e);
                if (!this._gaUserActed) return;
                if (this._gaStarted) return;
                this._gaStarted = true;
                this._track('rf_form_start', {});
            };
            this.container.addEventListener('change', fire);
            this.container.addEventListener('input', fire);
        }
        // セクション到達を1セクション1回だけ rf_step_reached (ファネル)
        _gaStep(section) {
            if (!section) return;
            const titleEl = section.querySelector ? section.querySelector('.rf-section-title') : null;
            const id = section.id || (titleEl ? titleEl.textContent.replace(/[*＊\s]+/g, '') : '');
            if (!id) return;
            // 🔴 初期描画で開いているセクションは「ユーザーが到達した」ではない。
            //    _gaStep() は描画経路から呼ばれるので、素のURLでも必ず1回出ていた。
            //    人が触るまでは **記録もしない** — ここで _gaSteps に入れてしまうと、
            //    操作開始後に第1段が永久に計上されずファネルの母数が壊れる。
            if (!this._gaUserActed) return;
            this._gaSteps = this._gaSteps || new Set();
            if (this._gaSteps.has(id)) return;
            this._gaSteps.add(id);
            this._track('rf_step_reached', { step: id });
        }
        // お試しプリントの分岐選択を 1値1回だけ rf_type_select (2026-08-24)
        // 目的: form_start 38.7% → add_to_cart 2.2% の落差を「セット / 1枚」で割る。
        //       いま 38.7% が“どちらを選んで”消えたのかが取れていない。
        // 🔴 初期同期は通らない: Liquid の checked を反映する初期呼び出しは
        //    setTimeout(handleOtameshiTypeChange) の直呼びで、この change ハンドラを経由しない。
        //    加えて _gaUserActed で合成 change (?variant= 付き着地の商品フィード広告) を弾く。
        //    ガードは _gaFormStart() と同一のフラグを使う (二重に持たない)。
        _gaOtameshiType(radio) {
            if (!radio) return;
            if (!this._gaUserActed) return;
            const raw = String((radio.dataset && radio.dataset.typeValue) || radio.value || '');
            const t = /セット|set/i.test(raw) ? 'set'
                : /シングル|1枚|single/i.test(raw) ? 'single'
                    : 'other';
            this._gaTypes = this._gaTypes || new Set();
            if (this._gaTypes.has(t)) return;   // 往復しても1値1回
            this._gaTypes.add(t);
            this._track('rf_type_select', { otameshi_type: t });
        }

        renderFirstError() {
            const all = this._pendingErrors || [];
            if (!all.length) return null;
            // 到達済み(=検証開始時に施錠されていなかった)エラーだけを対象にする。
            // 未到達セクションは上流の未入力が原因なので、そちらを先に出す。
            // 万一到達済みが1件も無ければ(安全網ケース)全体から出す。
            const reached = all.filter(p => !p.locked);
            const pool = reached.length ? reached : all;
            // 画面上の縦位置で最上位を選ぶ(検証コードの実行順ではなく見た目の順)。
            pool.forEach(p => {
                const r = p.el.getBoundingClientRect();
                p._top = r.top + window.pageYOffset;
            });
            const first = pool.slice().sort((a, b) => a._top - b._top)[0];
            // 選んだセクションが折り畳まれていれば開く(エラーを見えるようにする)。
            const ownSection = first.el.classList && first.el.classList.contains('rf-section')
                ? first.el : (first.el.closest ? first.el.closest('.rf-section') : null);
            if (ownSection) {
                ownSection.classList.add('rf-section-unlocked');
                ownSection.classList.remove('rf-locked-progressive');
            }

            const host = first.kind === 'field'
                ? (first.el.closest('.rf-input-group') || first.el.closest('.rf-section-content') || first.el.parentElement)
                : (first.el.querySelector('.rf-section-content') || first.el);
            if (!host) return first.el;

            if (first.kind === 'field') first.el.classList.add('rf-input-error');

            let box = host.querySelector(':scope > .rf-field-error');
            if (!box) {
                box = document.createElement('div');
                box.className = 'rf-field-error';
                box.setAttribute('role', 'alert');       // 支援技術にも読み上げさせる
                box.style.cssText = 'color:#c0392b;font-size:0.82rem;line-height:1.5;margin-top:0.5rem;font-weight:600;';
                host.appendChild(box);
            }
            box.textContent = first.msg;
            box.style.display = '';

            // 直したら消す(残し続けると嘘の警告になる)。
            const clearSel = first.kind === 'field' ? null : first.inputsSelector;
            const bindClear = (target) => {
                if (!target || target.dataset.rfErrClearBound) return;
                target.dataset.rfErrClearBound = '1';
                const clear = () => { box.style.display = 'none'; if (first.kind === 'field') first.el.classList.remove('rf-input-error'); };
                ['change', 'input'].forEach(t => target.addEventListener(t, clear));
            };
            if (first.kind === 'field') bindClear(first.el);
            else if (clearSel) first.el.querySelectorAll(clearSel).forEach(bindClear);

            // GA4: どの必須項目で受注が止まったか(離脱主因の実地図)
            const blockField = (ownSection && ownSection.querySelector('.rf-section-title'))
                ? ownSection.querySelector('.rf-section-title').textContent.replace(/[*＊\s]+/g, '')
                : (first.el.id || (first.msg || '').slice(0, 20));
            this._track('rf_validation_block', { field: blockField, message: (first.msg || '').slice(0, 40) });

            return first.el;
        }

        showTooltip(target) {
            const textKey = target.dataset.tooltip;
            const container = this.container.querySelector('#rf-tooltip-container');
            const content = this.container.querySelector('#rf-tooltip-content');

            const texts = {
                'layout-info': '「フチあり」は画像周囲に白フチがつきます。\n「フチなし」は用紙いっぱいに印刷されます（画像が数mmカットされます）。'
            };

            content.innerText = texts[textKey] || '';

            const rect = target.getBoundingClientRect();
            container.style.left = rect.left + 'px';
            container.style.top = (rect.bottom + 10) + 'px';
            container.classList.add('rf-visible');
        }

        hideTooltip() {
            this.container.querySelector('#rf-tooltip-container').classList.remove('rf-visible');
        }


    }

    // Expose to global scope for module entry point
    window.RationalFuturismForm = RationalFuturismForm;
}
